export default {
  date: {
    formats: {
      default: '%d-%m-%Y',
      short: '%-d %B',
      long: '%-d %B, %Y',
      with_day: '%A, %-d %B %Y',
      without_day: '%-d %B %Y',
    },
    day_names: [
      'søndag',
      'mandag',
      'tirsdag',
      'onsdag',
      'torsdag',
      'fredag',
      'lørdag',
    ],
    abbr_day_names: ['søn.', 'man.', 'tirs.', 'ons.', 'tors.', 'fre.', 'lør.'],
    month_names: [
      null,
      'januar',
      'februar',
      'marts',
      'april',
      'maj',
      'juni',
      'juli',
      'august',
      'september',
      'oktober',
      'november',
      'december',
    ],
    abbr_month_names: [
      null,
      'jan.',
      'feb.',
      'mar.',
      'apr.',
      'maj',
      'juni',
      'juli',
      'aug',
      'sept.',
      'okt.',
      'nov.',
      'dec.',
    ],
    order: [':år', ':måned', ':dag'],
  },
  number: {
    format: {
      separator: '.',
      delimiter: ',',
      precision: 3,
      round_mode: 'default',
      significant: false,
      strip_insignificant_zeros: false,
    },
    currency: {
      format: {
        format: '%u%n',
        unit: '$',
        separator: '.',
        delimiter: ',',
        precision: 2,
        significant: false,
        strip_insignificant_zeros: false,
      },
      EUR: '€',
      USD: 'US$',
      CAD: 'CAD',
      AUD: 'AUD',
      GBP: '£',
      DKK: 'kr',
      NOK: 'kr',
      SEK: 'kr',
    },
    percentage: {
      format: {
        delimiter: null,
        format: '%n%',
      },
    },
    precision: {
      format: {
        delimiter: null,
      },
    },
    human: {
      format: {
        delimiter: null,
        precision: 3,
        significant: true,
        strip_insignificant_zeros: true,
      },
      storage_units: {
        format: '%n %u',
        units: {
          byte: 'B',
          kb: 'KB',
          mb: 'MB',
          gb: 'GB',
          tb: 'TB',
          pb: 'PB',
          eb: 'EB',
        },
      },
      decimal_units: {
        format: '%n %u',
        units: {
          unit: null,
          thousand: 'Tusinde',
          million: 'Million',
          billion: 'Milliard',
          trillion: 'Billion',
          quadrillion: 'Billiard',
        },
      },
    },
    nth: {
      ordinals: {},
      ordinalized: {},
    },
  },
  datetime: {
    distance_in_words: {
      half_a_minute: '30 sekunder',
      less_than_x_seconds: {
        one: 'under et sekund',
        other: 'under %{count} sekunder',
        few: 'under %{count} sekunder',
        many: 'under %{count} sekunder',
      },
      x_seconds: {
        one: '1 sekund',
        other: '%{count} sekunder',
        few: '%{count} sekunder',
        many: '%{count} sekunder',
      },
      less_than_x_minutes: {
        one: 'under et minut',
        other: 'under %{count} minutter',
        few: 'under %{count} minutter',
        many: 'under %{count} minutter',
      },
      x_minutes: {
        one: '1 minut',
        other: '%{count} minutter',
        few: '%{count} minutter',
        many: '%{count} minutter',
      },
      about_x_hours: {
        one: 'ca. 1 time',
        other: 'ca. %{count} timer',
        few: 'ca. %{count} timer',
        many: 'ca. %{count} timer',
      },
      x_days: {
        one: '1 dag',
        other: '%{count} dage',
        few: '%{count} dage',
        many: '%{count} dage',
      },
      about_x_months: {
        one: 'ca. 1 måned',
        other: 'ca. %{count} måneder',
        few: 'ca. %{count} måneder',
        many: 'ca. %{count} måneder',
      },
      x_months: {
        one: '1 måned',
        other: '%{count} måneder',
        few: '%{count} måneder',
        many: '%{count} måneder',
      },
      about_x_years: {
        one: 'ca. 1 år',
        other: 'ca. %{count} år',
        few: 'ca. %{count} år',
        many: 'ca. %{count} år',
      },
      over_x_years: {
        one: 'over 1 år',
        other: 'over %{count} år',
        few: 'over %{count} år',
        many: 'over %{count} år',
      },
      almost_x_years: {
        one: 'næsten 1 år',
        other: 'næsten %{count} år',
        few: 'næsten %{count} år',
        many: 'næsten %{count} år',
      },
      x_years: {
        one: 'et år',
        other: '%{count} år',
      },
      x_weeks: {
        one: '1 uge',
        other: '%{count} uger',
        few: '%{count} uger',
        many: '%{count} uger',
      },
      x_hours: {
        one: '1 time',
        other: '%{count} timer',
      },
    },
    prompts: {
      year: 'år',
      month: 'måned',
      day: 'dag',
      hour: 'time',
      minute: 'minut',
      second: 'sekunder',
    },
  },
  'custom-wallpaper': {
    'aria-title': 'Wallpaper',
    'aria-label': 'Set Wallpaper',
    'aria-author': 'author:',
  },
  page: {
    plus: {
      button: {
        text: 'Opgrader til Pro',
      },
    },
    profile: {
      wallpapers: {
        best_1: 'Op til fem forskellige billeder',
        best_2: 'JPEG eller PNG',
        best_3: 'Op til %{size}',
        best_4: '%{resolution} pixels eller mere',
        best_5: 'Ingen GIF-filer eller video (beklager)',
        best_title: 'De vigtige detaljer:',
        text: 'Fremhæv dig selv eller dit brand med op til fem skiftende videoer eller billeder:',
        best_five: '%{videoResolution} pixels til videoer',
        best_four: '%{resolution} pixels til billeder',
        best_one: 'Op til fem videoer eller billeder',
        best_six:
          'Baggrunden skifter hvert %{rotationInterval} sekund. Derfor vil videoer, der er længere end %{rotationInterval}, blive kortet ned',
        best_three: 'Højst %{size} per video/billede',
        best_two: 'JPEG, PNG eller MP4',
        notice:
          "Trommehvirvel tak — der er kommet videobaggrunde! <a href='/profile'>Gør din baggrund til en video nu</a>.",
      },
      upsell: {
        benefit_one_alt: 'Få din egen WeTransfer-side',
        heading_alt: 'Aflever dit arbejde med stil',
        benefit_one: 'Få dit eget WeTransfer-domæne',
        benefit_three: 'Design dine egne e-mails til overførsler',
        benefit_two: 'Få vist personlige baggrunde, når dine filer downloades',
        button: {
          action: 'Læs mere',
        },
        heading: 'Fremhæv dit brand med WeTransfer Pro',
      },
      branding: {
        headline:
          '<strong>Send på bedste måde.</strong> Gør et godt indtryk, hver gang andre downloader dine filer.<br /> <strong>Gør det let at modtage.</strong> Alle kan uploade filer til dig som en del af dit abonnement.',
        protip: {
          text: '<strong>Pro tip:</strong> Anmoder du om en overførsel fra en person? Del et specielt link for at udfylde beskrivelsen på forhånd for dem.',
          link: 'Læs mere',
        },
      },
      pagename: 'Profilindstillinger',
      'onboarding-step-two':
        "Præsenter dine filer med stil, gør din WeTransfer-profil personlig, og nyd synet af det nye udseende på <a href='%{href}'>%{domain}</a>",
      email_backgrounds: 'Baggrunde til e-mails',
      sent_you_files: 'har sendt dig nogle filer',
      email_background_instruction_with_spec:
        'Du kan gøre dine overførsler unikke ved at sende dem med et baggrundsbillede.  \nBilledet må være op til %{size}. Vi anbefaler, at du bruger et billede på %{resolution} px for at få det flotteste resultat (bemærk, at vi er nødt til at beskære billeder, der er større end dette).',
      receiving: 'E-mail til din profil',
      choose_wallpapers: 'Baggrunde',
      'step-one-banner':
        'For at komme i gang skal du vælge en URL til din WeTransfer-side. Du kan altid ændre den senere.',
      description: {
        pro: 'Med din helt egen WeTransfer-side kan du gøre et godt indtryk, hver gang andre downloader dine filer. Og det er også dér, hvor alle kan sende dig overførsler med en størrelse på 200 GB som en del af dit WeTransfer Premium-abonnement.',
        premium:
          'Med din helt egen WeTransfer-side kan du gøre et godt indtryk, hver gang andre downloader dine filer. Og det er også dér, hvor alle kan sende dig overførsler af enhver størrelse som en del af dit WeTransfer Premium-abonnement.',
      },
      'instructions-1':
        'Du kan skifte dit navn og din URL så mange gange, som du har brug for.',
      'instructions-2':
        'Når du har valgt en ny URL, opdateres din side med det samme.',
      title: 'Rediger din side',
      profile_url: 'Profil-URL',
    },
    payment: {
      never_actived_retry:
        'Din konto er endnu ikke aktiv. Færdiggør registreringen for at begynde at bruge <a href="/payment/retry">%{planName}</a>',
      pagename: 'Plan og betaling',
      autorenew_heading: 'Betalingsoplysninger',
      autorenew_notice:
        'Dit %{planName} abonnement på %{deal} fornyes automatisk den %{autorenewal_attempt}',
      will_expire_notice:
        "Dit Pro-abonnement <span class='payment__notice'>udløber om %{daysBetween} dage</span>. Forny kontoen nu, eller sæt den til automatisk fornyelse.",
      never_actived_notice:
        'Din konto er endnu ikke akitveret. <a href="/payment/retry">Du skal fuldføre registreringen for at komme i gang med Pro.</a>',
      manual_renewal_expiry_notice: 'Din Pro-konto udløber den %{expiry}.',
      to_checkout: 'Gå til kassen',
      updating: 'Opdaterer...',
      yes_disable: 'Ja tak, fortsæt',
      review_billing_link: 'Vil du opdatere din betalingsmetode?',
      autorenew_failed:
        "Dit Pro-abonnement på %{deal}/%{period} udløber <span class='payment__notice'><strong>om %{daysBetween} dage</strong>. Vi kunne ikke forny kontoen for dig – forny kontoen manuelt før den <strong>%{expiry}</strong>.</span>",
      confirm_disable_autorenew:
        'Er du sikker på, at du vil stoppe automatisk fornyelse?',
      disable_autorenewal: 'Stop automatisk fornyelse',
      enable_autorenewal: 'Aktivér automatisk fornyelse',
      renew_now: 'Forny nu',
      subscription_expired: 'Dit Pro-abonnement er udløbet.',
      cancel_heading: 'Er det tid til at komme videre?',
      cancel_info:
        'Det er, hvad der sker. Når du har opsagt dit abonnement, passer vi på dine filer i yderligere 30 dage (nej, vi gemmer dem ikke under hovedpuden – så underlige er vi ikke), hvis nu du skulle have glemt noget. Du kan også til enhver tid genaktivere dit abonnement',
      cancel_info_subscription:
        'Der er, hvad der sker. Når du har opsagt dit abonnement, kan du bruge din Pro-konto frem til den %{subscriptionExpiryDate}. Derefter passer vi på dine filer i yderligere 30 dage (nej, vi gemmer dem ikke under hovedpuden – så underlige er vi ikke), hvis du nu skulle have glemt noget. Du kan også til enhver tid genaktivere dit abonnement.',
      cancel_now: 'Opsig abonnement',
      cancelling: 'Opsiger ...',
      confirm_cancel_subscription:
        'Er du sikker på, at du vil opsige dit abonnement?',
      confirm_reactivate_subscription:
        'God beslutning! Du mangler bare ét klik for at genaktivere din betalingsmetode',
      manual_renewal_in_future_notice:
        'Dit Pro-abonnement på %{deal}/%{period} udløber om %{daysBetween} dage. Du kan forny kontoen manuelt efter den %{manual_renewal_available_at}, eller aktivere automatisk fornyelse nu.',
      reactivate_heading: 'Lad os starte forfra.',
      reactivate_content_top_pro:
        'Du kan genaktivere dit %{planName}-abonnement, og det vil være det samme, som før du opsagde det. Eller du kan vælge at opgradere til WeTransfer Premium:',
      reactivate_content_top_premium:
        'Du kan genaktivere dit %{planName}-abonnement, og det vil være det samme, som før du opsagde det.',
      reactivate_content_bottom_pro:
        'Hvis du opgraderer til Premium, vil du blive opkrævet %{upfront_payment}, og du vil kunne bruge WeTransfer Premium med det samme. Dit nye abonnement på %{recurring_payment}/%{interval} fornyes den %{recurring_date}.',
      reactivate_pro: 'Genaktiver Pro',
      reactivate_premium: 'Genaktiver Premium',
      reactivate_upgrade_to_premium: 'Opgrader til Premium',
      reactivating: 'Genaktiverer...',
      subscription_cancelled:
        'Dit abonnement er opsagt og udløber automatisk om %{daysBetween} dage.',
      subscription_reactivate_expired_notice:
        'Din Pro-konto er blevet annulleret.',
      subscription_reactivate_notice_pro:
        'Dit %{planName} abonnement er blevet opsagt og udløber automatisk om %{daysBetween} dage.\n',
      subscription_reactivate_notice_premium:
        'Dit %{planName} abonnement er blevet opsagt og udløber automatisk om %{daysBetween} dage.\nHar du fortrudt? Bare rolig, det er nemt at få tingene op at køre igen.',
      subscription_reactivate_notice_trial_before:
        'Dit %{planName} abonnement er blevet opsagt og udløber automatisk om %{daysBetween} dage.\nDu kan fortsat nyde godt af din WeTransfer Premium-prøveperiode, indtil dit abonnement udløber.',
      subscription_reactivate_notice_trial_after:
        'Dit %{planName} abonnement er blevet opsagt og udløber automatisk om %{daysBetween} dage.\nDu kan fortsat nyde godt af din WeTransfer Premium-prøveperiode indtil %{trialExpiryDate}.',
      update_method_link: 'Opdater betalingsoplysninger',
      autorenew_notice_teams:
        'Den %{autorenewal_attempt} bliver dit %{planName}-abonnement på %{deal} automatisk fornyet for dit team på %{number_of_members} medlemmer.',
      cancellation_cta: 'Opsig abonnement',
      cancellation_heading:
        'Har du ikke længere brug for fordelene ved %{planName}?',
      cancellation_heading_trial: 'Opsig abonnement',
      cancellation_text:
        'Hvis du opsiger dit abonnement, vil du fortsat have adgang til Pro frem til den %{subscriptionExpiryDate}. Derefter konverteres din WeTransfer Pro-konto til en gratis konto, og dine nuværende overførsler udløber 28 dage senere.',
      cancellation_text_item_1: 'Sende op til %{transfer_limit}',
      cancellation_text_item_2: 'Beskytte overførsler med en adgangskode',
      cancellation_text_item_3:
        'Håndtere og gemme filer på op til %{storage_limit}',
      cancellation_text_item_4: 'Have din egen URL og tilpasset Pro-side',
      cancellation_text_item_heading:
        'Med en gratis konto kan du højst sende %{free_size_limit} pr. overførsel. Du vil ikke længere kunne:',
      cancellation_text_new:
        'Hvis du opsiger dit abonnement, vil du kunne bruge %{planName} frem til den %{subscriptionExpiryDate}. Derefter nedgraderes din konto til en gratis plan.<br /><br />Bemærk, at alle eksisterende overførsler udløber senest 28 dage efter, at dit abonnement slutter.',
      cancellation_text_teams:
        'Hvis du opsiger dit abonnement nu, kan du og dit team bruge %{planName} indtil den %{subscriptionExpiryDate}.<br /><br />Derefter kan du og dine teammedlemmer ikke længere sende filoverførsler, oprette præsentationsdias eller lave tavler sammen. Du bliver nedgraderet til den gratis plan, og du kan kun logge ind på din egen WeTransfer-konto.<br /><br />Bemærk, at alle eksisterende overførsler udløber senest 28 dage efter, at dit abonnement slutter.',
      premium_trial: {
        feature_list_item_1: 'Ingen grænser for størrelser på overførsler',
      },
      premium_upgrade: {
        cta: 'Skift til Premium',
        description:
          'Du vil blive opkrævet %{upfront_payment}, og du kan begynde at bruge WeTransfer Pro med det samme. Dit nye abonnement på %{recurring_payment} per %{interval} vil blive fornyet den %{recurring_date}.',
        feature_list_item_1:
          'Send overførsler uden begrænsning af filstørrelser',
        feature_list_item_2: 'Ubegrænset lagerplads',
        feature_list_item_3: 'Ubegrænsede portaler og rettelser/gennemgange',
        feature_list_item_4: '%{storageLimit} lagerplads',
        heading: 'Ønsker du opgradere dit abonnement?',
      },
      unpaid_invoices: {
        heading: 'Du har ubetalte fakturaer',
        item: {
          issued_on: 'Udstedt den',
          pay_invoice: 'Betal faktura',
          pending_invoice: 'Venter...',
        },
        subheading:
          'Det ser ud til, at der var et problem med dine tidligere betalinger. Betal venligst eventuelle udestående fakturaer, ellers kan dit Pro-abonnement blive annulleret.',
        subheading_2:
          'Bare rolig, hvis du har afventende fakturaer - vi prøver igen om et par dage, og du vil være klar, så snart betalingen er gennemført.',
      },
      upgrade_cta: 'Opdater',
      app_subscription_banner: {
        title: 'Du abonnerer fra %{app_name}',
        content:
          'Hvis du vil se eller administrere dit abonnement, skal du logge på din %{app_name} konto fra din telefon eller computer.',
        go_to: 'Gå til',
        learn_more: 'Læs mere',
      },
    },
    'payment_cancel-verify': {
      cancellation_cta: 'Opsig abonnement',
      cancellation_disclaimer:
        '*Bemærk, at dine eksisterende overførsler udløber allerede 28 dage efter, at din konto er konvertetet.',
      'current-plan': 'Nuværende abonnement',
      'free-forever': 'Gratis for altid',
      'free-usp-1': 'Send op til 2 GB',
      'free-usp-2': 'Ingen lagerplads',
      'free-usp-3': 'Overførsler udløber efter 7 dage*',
      'heading-free': 'WeTransfer',
      'heading-pro': 'WeTransfer Pro',
      intro:
        'Hvis du opsiger dit abonnement nu, kan du fortsætte med at bruge WeTransfer Pro frem til den <b>%{expiration_date}</b>. Derefter konverteres kontoen til en gratis WeTransfer-konto – hvilket stadig er ret fedt.',
      pagename: 'Har du ikke længere brug for Pro?',
      'pro-usp-1': 'Send og modtag op til %{transfer_limit}',
      'pro-usp-2': '1 TB lagerplads',
      'pro-usp-3': 'Bestem, hvornår overførsler skal udløbe',
      'pro-usp-4':
        '<p>Din egen <a href="/profile?utm_source=pro_pass&utm_medium=usp_4_link&utm_campaign=cancel_verify">Pro-side</a></p>',
      'pro-usp-5':
        '<a href="https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=usp_5_link&utm_campaign=cancel_verify">Oplev Paste® Pro og Collect Pro</a>',
    },
    payment_cancel: {
      info_with_end_date:
        '<p>Du har nu opsagt dit Pro-abonnement. Din konto bliver konverteret til en gratis WeTransfer-konto efter den <b>%{ends_at}.</b></p> \n<p>Fortæl os, hvorfor du forlader os, så vi kan forbedre WeTransfer Pro med dig i tankerne.</p>',
      reason_header: 'Vi er kede af, at du forlader os',
      cancel: 'Tilbage',
      info: 'Fortæl os, hvorfor du forlader os, så vi kan fortsætte med at forbedre WeTransfer Pro med dig i tankerne.',
      pagename: 'Inden du forlader os',
      yes_disable: 'Ja, opsig',
    },
    payment_failed: {
      selected_product: 'En %{duration} af %{planTier}',
      change: 'Opdatér',
      complete_order: 'Gennemfør ordren',
      description: 'Gennemse oplysningerne, og gennemfør ordren',
      description_error:
        'Der gik noget galt — tjek dine oplysninger igen, og fortsæt til kassen',
      description_refused:
        'Vi kunne ikke gennemføre betalingen — kontrollér betalingsoplysningerne, og prøv igen',
      discount: 'Rabat',
      product_description: '%{duration} WeTransfer Pro',
      title: 'Du er næsten klar!',
      total: 'I alt',
      vat: 'Moms',
      your_details: 'Dine oplysninger',
      your_order: 'Din ordre',
      title_error: 'Hmm, der ser ud til at være et problem',
      title_refused: 'Hmm, der ser ud til at være et problem',
      payment_status_message:
        'Din betaling lykkedes, men noget gik galt, og vi kunne ikke opdatere din plan automatisk. <a href="https://wetransfer.zendesk.com/hc/en-us/requests/new" rel="external">Kontakt support</a>',
    },
    payment_methods: {
      billed_now: 'Betalt nu',
      info_content: {
        cancel_bullet:
          'Bare rolig, du finder stedet hvor man kan afmelde sit abonnement under Kontoindstillinger > Betaling',
        initial_payment_bullet:
          'Efter første betaling vil du blive opkrævet %{price} hver%{interval} (medmindre du afmelder dit abonnement - men det ville du ikke gøre, vel? Vel?)',
        update_payment_bullet:
          'Du kan altid opdatere dine betalingsoplysninger og/eller faktureringsoplysninger inden din næste betaling opkræves.',
        month:
          '- Efter første betaling vil du blive opkrævet %{price} hver måned (medmindre du afmelder dit Pro-abonnement) \n- Du kan til enhver tid opsige dit abonnement ved at gå til Kontoindstillinger > Betaling.\n- Du kan altid opdatere din betalingsmetode og/eller dine virksomhedsdetaljer, inden den næste betaling forfalder.',
        year: '- Efter din første betaling, vil du årligt blive opkrævet %{price} (med mindre du opsiger dit Pro-abonnement - men det gør du ikke, vel? Vel?!)\n- Bare rolig, du kan opsige dit abonnement ved at gå til Kontoindstillinger > Betaling.\n- Du kan altid opdatere din betalingsmetode og/eller dine virksomhedsdetaljer, inden den næste betaling falder.',
      },
      payment_cta: 'Udfør betaling',
      payment_term: {
        monthly: 'pr. måned',
        yearly: 'pr. år',
      },
      payment_title: 'Betaling',
      plan_details: {
        premium: 'WeTransfer Premium',
        pro: 'WeTransfer Pro',
        month: 'Månedligt',
        year: 'Årligt',
      },
      subtotal: 'Subtotal',
      legislation_text:
        'Ich fordere und stimme ausdrücklich zu, dass Sie mit der von mir bestellten Dienstleistung vor Ablauf der Widerrufsfrist beginnen. Mir ist bekannt, dass mein Widerrufsrecht mit vollständiger Vertragserfüllung erlischt.*',
      legislation_footer:
        '* Hier finden Sie die <a href="/legal/terms?overrideLanguage=de" target="_blank">Nutzungsbedingungen</a> und <a href="/documents/Datenschutz_und_Cookierichtlinie.pdf" target="_blank">Datenschutz- und Cookie-Erklärung.</a>',
      your_payment_method: 'Din betalingsmetode',
      bancontact: 'Bancontact',
      card: 'Kreditkort',
      card_cvc: 'Kontrolcifre',
      card_expiration: 'mm / åå',
      card_name: 'Navn på kort',
      card_number: 'Kortnummer',
      complete_payment: 'Gennemfør betaling',
      creditcard: 'Kreditkort',
      discount: 'Rabat',
      do_not_refresh: 'Undgå at genindlæse eller lukke siden',
      ideal: 'iDEAL',
      ideal_info:
        'iDEAL er en hollandsk betalingsmetode, hvor kunder kan foretage betalinger gennem deres egen bank.',
      info: 'Opdater betalingsmetode',
      payment_in_progress: 'Vi behandler din betaling...',
      paypal: 'PayPal',
      plan_name: 'WeTransfer Pro',
      price_period: {
        month: 'om måneden',
        year: 'om året',
      },
      select_bank: 'Vælg din bank',
      select_country: 'Vælg land',
      sofort: 'SOFORT',
      tax: 'Moms',
      title: 'Vælg din betalingsmetode',
      total: 'I alt',
    },
    projects: {
      actions: {
        go_back: 'Alle projekter',
        discard: 'Kassér ændringer',
        edit: 'Rediger',
        remove_transfer:
          'Slet denne overførsel? Filerne fjernes fra dette projekt og sendte overførsler.',
        save: 'Gem',
        share: 'Del',
      },
      transfer_actions: {
        download: 'Download',
      },
      added_at: 'kl. %{timeOfDay}',
      clipboard_modal: {
        copy_link: 'Kopiér link',
        link_copied: 'Link kopieret til udklipsholder',
        content_label: 'Kopier link til dette projekt',
        list_item_1: 'Adgang til at downloade og se',
        list_item_2: 'Link forbliver det samme, for evigt',
        title: 'Del projekt',
      },
      content: {
        empty_state:
          'Dit projekt er i øjeblikket tomt. Kom i gang ved at tilføje nogle filer for at starte en tidslinje for dit projekt.',
      },
      logo_title: 'Gå tilbage til wetransfer.com',
      logo_tooltip_caption: 'Tilbage til WeTransfer',
      timestamp: '%{timeAgo} siden',
      chat: {
        owner_button_label: 'Pst... Tal med os',
        owner_offline_greeting:
          'Vi er i øjeblikket offline, men fortæl os, hvad du har problemer med, så kontakter vi dig inden for en arbejdsdag.',
        owner_online_greeting:
          'Fortæl os, hvad du har problemer med, så kontakter vi dig, så snart vi kan',
        receiver_button_label: 'Har du spørgsmål? Vi er her for at hjælpe',
        receiver_offline_greeting:
          'Fortæl os, hvad du har problemer med, så kontakter vi dig, så snart vi kan.',
        receiver_online_greeting:
          'Fortæl os, hvad du har problemer med, så kontakter vi dig, så snart vi kan.',
      },
      created_by: 'Oprettet af %{user}',
      created_by_fallback: 'Oprettet',
      deliverable_clipboard_modal: {
        content_label: 'Kopier link til denne leverance',
        info: 'Andre vil også kunne se dit projekt',
        title: 'Del leverance',
      },
      deliverables: {
        add_deliverable: 'Add a deliverable',
        add_files: 'Add files',
        cancel_upload: 'Cancel this upload?',
        clear_all_files_option: 'Clear all files',
        create_deliverable: {
          input_placeholder_0: 'Rough illustrations',
          input_placeholder_1: 'Brand guidelines',
          input_placeholder_2: 'Royalty-free SFX samples',
          input_placeholder_3: 'Color corrected video',
          input_placeholder_4: 'Voiceover recordings from my closet',
          input_placeholder_5: 'Quick sketches for quick approval',
          input_placeholder_6: '10,000 storyboard options',
          input_placeholder_7: 'The first video cut is the deepest',
          input_placeholder_8: 'Raw photos (for selection)',
          input_placeholder_9: 'My music reco (plus five lousy other options)',
        },
        create_deliverable_cancel: 'Cancel',
        create_deliverable_label: 'What will you deliver?',
        create_deliverable_save: 'Save',
        date: {
          updated_today: 'Updated today',
          updated_yesterday: 'Updated yesterday',
        },
        delete_option: 'Delete',
        deliverable_cleared:
          'Cleared all files from <strong><u>%{deliverableName}</u></strong>',
        deliverable_deleted:
          '<strong><u>%{deliverableName}</u></strong> has been deleted',
        deliverable_label: 'Deliverable',
        edit_option: 'Edit',
        edit_prompt: 'Rename this deliverable or add a description',
        empty_deliverable_state: 'No files yet. Coming soon',
        more_option: 'More',
        no_deliverables: {
          heading: 'Add a deliverable<br />to upload files',
        },
        no_deliverables_not_project_owner: {
          heading:
            '%{projectOwner} hasn’t added any deliverables for this project yet.',
        },
        processing_deliverable_state: 'Processing...',
        rename_option: 'Rename',
        share_option: 'Share',
        upload_cancel: 'Cancel',
        upload_files: 'Upload files',
        uploading: 'Uploading...',
        uploading_paused: 'Upload paused...',
        view: 'View',
      },
      errors: {
        blank: 'Dette er ikke det projekt, du leder efter...',
        limit: 'Dit potentiale er uendeligt, men du har nået grænsen for tegn',
        required: 'Du ved, hvad du skal. Du bliver nødt til at udfylde dette',
      },
      event: {
        project_created_byline:
          'Tilføj nogle filer for at vise, hvad du arbejder på.',
        project_created_title: 'Start af projektet',
      },
      file_count: {
        one: '%{count} fil',
        other: '%{count} filer',
      },
      just_now: 'lige nu',
      labels: {
        description: 'Beskrivelse',
        name: 'Navn',
        new_name: 'Navngiv dit projekt',
      },
      logo: {
        cta: 'Tilføj et logo',
        errors: {
          dimensions:
            'Dit logo er mindre end 220 x 220 px. Prøv et større billede',
          general: 'Hmm, noget gik galt Prøv igen',
          size: 'Dit logo er større end 5 MB. Prøv en mindre fil',
          type: 'Dit logo er ikke en JPEG, GIF eller PNG. Prøv et andet billede',
        },
        instructions:
          "Dit logo kan være op til 5 MB. JPEG'er og GIF'er er okay, men PNG'er med en gennemsigtig baggrund fungerer bedst",
        'instructions-title': 'Vis dit brand frem',
      },
      name_modal: {
        content_label: 'Navngiv eller omdøb dit projekt',
        input_placeholder_0: 'Absolut en Cannes-pris værdig',
        input_placeholder_1: 'En kur mod forkølelsen',
        input_placeholder_2: 'Den perfekte forbrydelse',
        input_placeholder_3: 'Jeg skriver sange, ikke titler',
        input_placeholder_4: 'Prisvindende idé',
        input_placeholder_5: 'Helt ny brandkampagne',
        input_placeholder_6: 'Verdensherredømme',
        save: 'Gem',
        text: 'Beskriv, hvad du arbejder på.',
        title: 'Navngiv dit projekt',
      },
      new_project_label: 'Start nyt projekt',
      noticebar: {
        'button-cancel': 'Annuller',
        'button-clear-all-files': 'Ryd alt',
        'button-close': 'Luk',
        'button-delete': 'Slet',
        'button-no': 'Nej',
        'button-share': 'Del',
        'button-yes': 'Ja',
        'confirm-cancel': 'Vil du annullere overførslen?',
        'confirm-clear-files-deliverable':
          'Ryd alle filer fra <strong><u>%{deliverableName}</u></strong>?',
        'confirm-complete':
          'Overførsel gennemført! Fortæl alle, at du har tilføjet flere filer.',
        'confirm-delete-deliverable':
          'Vil du slette <strong><u>%{deliverableName}</u></strong> og eventuelle filer, du har uploadet til overførslen?',
        'confirm-first-complete':
          'Overførsel gennemført! Del dette projekt, så dine filer kan downloades.',
        deliverable_not_found_error:
          'Det ser desværre ud til at den leverance er blevet slettet',
        general_error: 'Ups, der gik noget galt. Prøv venligst igen.',
      },
      'onboarding-promise': {
        description:
          'Skitser alt det arbejde, du vil levere til et projekt, og strømlin den måde, du deler på. Opret en liste over leverancer, og tilføj derefter filer, efterhånden som du arbejder dig gennem dem. Derved undgår du flere forskellige downloadlinks.',
        title: 'Start på sporet for at holde dig på sporet',
      },
      onboarding: {
        banner:
          'Bemærk! Du er en af de få udvalgte med adgang til Projekter, mens det stadig er ved at blive bygget (og forbedres). Vi vil måske kontakte dig for at få feedback.',
      },
      pagename: 'Projekter',
      placeholders: {
        description: 'Giv en kort beskrivelse af dit projekt',
        loading: 'Indlæser...',
      },
      project: {
        notification: {
          name_saved: 'Navn gemt! Dit projekt lyder som en vinder.',
        },
      },
      share_button_label: 'Del',
      unnamed_project_title: 'Ikke navngivet projekt',
      watch_video: 'Se video',
    },
    transfer: {
      display_name_fallback: 'Overførsel uden titel',
      does_not_expire: 'ingen <u>dato for udløb</u>',
      expires_in: 'Udløber om <span>%{time}</span>',
      downloaded_at: 'Downloadet den %{date} kl. %{time}',
      not_downloaded: 'Endnu ikke downloadet',
      email_bounced:
        'Hmm, den e-mailadresse, du sendte overførslen til, fungerer ikke',
      count_files: {
        one: '%{count} fil',
        other: '%{count} filer',
      },
      sent_datetime: 'Sendt den %{date} kl. %{time}',
      never_expires: 'Ingen dato for udløb',
      and_more: 'Og %{count} flere',
      read_more: 'mere',
      copy_link: 'Kopiér link',
      message: 'Besked',
      total_downloads: 'Downloads i alt',
      sent_to_recipients: {
        one: 'Sendt til %{count} person',
        other: 'Sendt til %{count} personer',
      },
      no_transfers: 'Alle sendte overførsler vises her',
      add_first_description:
        'Se downloadstatus, rediger, videresend, eller slet dem',
      mobile: {
        download: 'Download alle filer',
        remove: 'Slet overførsel',
      },
      delete_datetime: 'Filer slettet %{date} klokken %{time}',
      detail: {
        plus_download_stats:
          'Få Pro, og se hvor mange gange dine overførsler bliver downloadet.',
        plus_password_expiration:
          'Få Pro, og opret adgangskoder og udløbsdatoer for dine overførsler.',
        plus_transfer_actions:
          'Få Pro, og få styr på dine overførsler eller slet dem, når du ønsker.',
        title: 'Dine overførselsdetaljer',
      },
      download_status_email: '%{count} ud af %{total} personer',
      download_status_email_text: {
        zero: 'Endnu ikke downloadet',
        one: '%{count} ud af %{total} personer',
        other: '%{count} ud af %{total} personer',
      },
      download_status_link: {
        one: 'en gang',
        other: '%{count} gange',
      },
      download_status_link_text: {
        zero: 'Endnu ikke downloadet',
        one: '1 gang',
        other: '%{count} gange',
      },
      sent_moment: 'Sendt %{moment}',
      total_downloads_tooltip:
        'Anderledes end du forventede? Vi lavede en lille ændring for nylig. Dette tal viser kun fuldførte downloads.',
      display_name: {
        label: 'Titel',
        label_mobile:
          'Tilføj en titel, så folk ved, hvad din overførsel indeholder',
      },
      download_status_received_text: {
        zero: 'Endnu ikke downloadet',
        one: 'Downloadet',
        other: 'Downloadet',
      },
      edit_display_name: {
        cancel: 'Annuller',
        save: 'Gem',
        title: 'Titel',
      },
      received_datetime: 'Modtaget den %{date} kl. %{time}',
      received_from: 'Modtaget fra',
      received_moment: 'Modtaget %{moment}',
      teams: {
        received_by: 'Modtaget af',
        self: 'mig',
        sent_by: 'Sendt af',
      },
      title: 'Titel',
      set_password: {
        added: 'Tilføjet',
        change: 'Rediger',
        remove: 'Fjern',
        description:
          'Indstil en adgangskode for at kontrollere, hvem der har adgang til denne overførsel.',
        remove_warning:
          'Vil du fjerne adgangskodebeskyttelsen fra denne overførsel?',
        yes_remove: 'Ja, fjern',
      },
      set_expiration: {
        description:
          'Indstil en udløbsdato for at begrænse adgangen til denne overførsel.',
        label: 'Udløber om',
      },
      anon_upsell_no_account:
        'Hvis du vil redigere eller spore downloads for denne overførsel, før den udløber, skal du <a href="%{href}">tilmelde</a> dig gratis.',
      anon_upsell_found_account:
        'Hvis du vil redigere eller spore downloads for denne overførsel, før den udløber, skal du <a href="%{href}">logge ind</a>.',
      anon_upsell_no_account_with_button:
        'Du kan redigere denne overførsel, før den udløber, ved at oprette en konto.',
      create_free_account: 'Opret en gratis konto',
    },
    transfers: {
      space_used_unlimited: ' %{space} lagerplads er i brug',
      pagename: 'Overførsler',
      search: 'søg efter filnavn',
      search_results: {
        one: '%{count} søgeresultat',
        other: '%{count} søgeresultater',
        none: 'Ingen resultater',
        retry:
          'Vi kunne ikke finde nogen overførsel, der passer til din søgning – prøv igen.',
      },
      space_used: '%{space} af %{totalSpace} brugt',
      selected_text: {
        one: '%{count} overførsel valgt (%{size})',
        other: '%{count} overførsler valgt (%{size})',
      },
      last_7_days: 'Sendt de seneste syv dage',
      over_7_days: 'Sendt for mere end syv dage siden',
      sort_on: 'Sortér efter:',
      size: 'Størrelse',
      name: 'Navn',
      date: 'Dato',
      delete: 'Slet',
      download: 'Download',
      forward: 'Videresend',
      remove: 'Slet',
      select: 'Vælg',
      copy_link: 'Kopiér link',
      sent_time_ago: 'Sendt for %{timeAgo} siden',
      files: {
        one: '%{count} fil',
        other: '%{count} filer',
      },
      confirm_transfer_delete:
        'Lige et øjeblik – er du sikker på, at du vil slette overførslen?',
      confirm_forward:
        'En videresendelse vil afbryde den igangværende overførsel. Vil du fortsætte?',
      confirm_expired_transfer_delete:
        'Dette vil slette filerne og overførselsoplysningerne permanent. Fortsæt?',
      deleting_now: 'Vi sletter dette for dig nu',
      deselect_all_transfers: {
        one: 'Fravælg alle overførsler',
        other: 'Fravælg alle %{count} overførsler',
      },
      downloads: 'Downloads',
      expiration: 'Udløbsdato',
      expiration_next: 'Udløber næste %{days}',
      expiration_no_date: 'Der er ingen udløbsdato',
      expiration_not_soon: 'Udløber ikke foreløbigt',
      include_archived_switch_label:
        'Medtag oplysninger for slettede overførsler',
      include_archived_switch_tooltip:
        'Disse tæller ikke med i forhold til din lagergrænse',
      notify_completed:
        'Overførsel gennemført. Du kan nu lukke panelet. Eller blive ved med at kigge på det, hvis du skulle have lyst.',
      preview: 'Forhåndsvisning',
      remove_permanently: 'Fjern oplysninger permanent',
      search_placeholder: 'Søg efter filnavn eller e-mail',
      select_all_transfers: {
        one: 'Vælg alle overførsler',
        other: 'Vælg alle %{count} overførsler',
      },
      space_left: '%{space} af %{totalSpace} tilbage',
      teams_tip: {
        subtitle:
          'Denne side viser din egen overførselaktivitet. Og du skal vide, at de andre i dit team også kun kan se deres egne overførsler.',
        title: 'Dit Pro-team vokser…',
      },
      title: 'Sendte overførsler',
      view_details: 'Se detaljer',
      edit_display_name: 'Rediger titel',
      received_time_ago: 'Modtaget for %{timeAgo} siden',
      search_title_placeholder: 'Søg efter titel, filnavn eller e-mail',
      see_all: 'Vis alle (%{count})',
      sender: 'Afsender',
      sort_by_title: 'Titel',
    },
    accountinfo: {
      pagename: 'Kontooplysninger',
      signed_in_as: 'Logget ind som %{name}',
      sign_out: 'Log ud',
      paid_on: 'Betalt den',
      no_invoices:
        'Dine kvitteringer vil blive vist her, men det ser ud til, at du endnu ikke har modtaget nogen. Du er heldig!',
      subscription_info:
        'Dit Pro-abonnement på %{deal} fornyes automatisk den %{autorenewal_attempt}.',
      payment_success: {
        monthly: 'Super - du er nu klar til en hel måned med WeTransfer Pro',
        monthly_renewal: 'Fint - så er du klar til endnu en måned med Pro',
        yearly: 'Super - du er nu klar til et helt år med WeTransfer Pro',
        yearly_renewal: 'Fint - så er du klar til endnu et år med Pro',
      },
    },
    changepassword: {
      pagename: 'Skift adgangskode',
    },
    invoices: {
      pagename: 'Kvitteringer',
    },
    reviewbilling: {
      pagename: 'Bekræft dine betalingsoplysninger',
      information:
        'Før vi kan ændre betalingsmetoden, er vi nødt til samtidig at forny abonnementet',
      information_payment:
        'Du opkræves %{deal} for %{period} Pro – dit abonnement gælder indtil %{expiry}',
    },
    renewbilling: {
      pagename: 'Gennemgå oplysningerne og forny',
    },
    link_downloads_unsubscribe: {
      body: 'Du kan framelde dig notifikationer vedrørende downloads – og stadig holde styr på downloads af filer i din Sendt-bakke.',
      cta: 'Gå til mine sendte overførsler',
    },
    onboarding: {
      step_two: {
        wallpaper: {
          choose_button: 'Vælg fra galleriet',
        },
        next_button: 'Klar',
        description:
          'Vælg baggrundstapet og beslut, hvordan din profil og dine download-sider skal se ud. Smart, ikke? Du kan uploade dit eget - ellers har vi stillet et par muligheder til rådighed.',
      },
      upload_wallpaper: {
        add_text: 'Upload et billede',
        add_description:
          'For de bedst mulige resultater foreslår vi, at du uploader et billede på 2560 x 1600 pixels. Maks. filstørrelse er 3 MB.',
        upload_text: 'Upload et billede eller en video',
      },
      preview: {
        wallpaper_credits_prefix: 'Tapet af',
      },
      1: {
        description:
          '&quot;Tilpas, hvad modtageren ser, hver gang du sender filer til dem. Med din egen WeTransfer-side kan alle sende dig overførsler på op til %{transfer_limit} – du skal bare giv dem din URL-adresse. Din e-mailadresse vil blive vist på siden, så afsendere kan tjekke, at deres filer sendes til dig.<br /><br />\nDu skal først vælge din URL-adresse.&quot;',
        next: 'Næste',
        skip: 'Spring over',
        warning: 'Bemærk, at profilen kun kan indstilles én gang!',
        'blurb-1':
          'Opret din egen WeTransfer-side for at se mere professionel ud, hver gang nogen downloader dine filer. Det gør det også lettere for andre at sende dig overførsler.',
        'blurb-2': 'Vælg først din URL.',
        welcome: 'Sæt dit aftryk med din egen WeTransfer-side',
        information:
          'Bare rolig, du kan altid ændre det senere i <strong>Branding</strong>.',
        description_unlimited:
          'Tilpas hvad folk ser, hver gang du sender dem filer. Og med din egen WeTransfer-side kan alle sende dig overførsler af enhver størrelse - bare giv dem din url. Din e-mailadresse vises på siden, så andre kan se, at filerne sendes til dig.<br /><br /> \nMen først skal du vælge din url.',
      },
      2: {
        description:
          'Du kan vælge op til fem forskellige baggrunde (eller tapeter, som vi kalder dem) til din profil.\n\nFremhæv dig selv eller dit brand og send dine filer med dit eget aftryk',
        pick: 'Vælg fra vores galleri',
        title: 'Sæt dit aftryk på hver enkelt overførsel',
        upload: 'Upload din egen',
      },
      3: {
        description:
          '<strong>%{customLink}</strong> er klar til brug. Nu kan du føje dette link til din hjemmeside, så andre kan sende dig overførsler med en størrelse på op til %{transfer_limit} - eller du kan selv sende ting.',
        done: 'Afslut',
        title: 'Sikke en indbydende profil',
        description_unlimited:
          '<strong> %{customLink} </strong> er klar til brug. Nu kan du føje dette link til din hjemmeside, så folk kan sende dig overførsler af enhver størrelse - eller du kan selv sende ting...',
      },
    },
    contact: {
      add_contact: 'Tilføj kontakt',
      add_first_description:
        'Her gemmer vi de e-mailadresser, du sender filer til',
      add_to_transfer: 'Tilføj til overførsel',
      remove_from_transfer: 'Fjern fra overførsel',
      confirm_delete: {
        one: 'Er du sikker på, at du vil slette denne kontakt?',
        other: 'Er du sikker på, at du vil slette %{count} kontakter?',
      },
      contact_count: {
        one: '%{count} kontakt',
        other: '%{count} kontakter',
      },
      edit: 'Rediger',
      mobile: {
        add: 'Tilføj kontakt',
      },
      no_contacts: 'Tilføj din første kontakt!',
      pagename: 'Kontakter',
      remove: 'Slet',
      search_count: {
        one: '%{count} søgeresultat',
        other: '%{count} søgeresultater',
      },
      search_placeholder: 'søg efter e-mail, navn eller virksomhed',
      select: 'Vælg',
      selected_text: {
        one: '%{count} kontakt valgt',
        other: '%{count} kontakter valgt',
      },
      teams_tip: {
        subtitle:
          'Når du sender nogen en overførsel, tilføjes pågældende til din liste over kontakter. Alle i dit team kan lave deres egen liste.',
        title: 'Dit Pro-team vokser…',
      },
    },
    unsubscribeexpiration: {
      button: 'Afmeld',
      button_unsubscribed: 'Tilbage til WeTransfer',
      description:
        'Er du træt af vore e-mails? Det er helt i orden. Vi kan undlade at sende dig påmindelser om filer, der snart udløber.',
      description_unsubscribed:
        'Du vil ikke længere modtage e-mails om overførsler, der er ved at udløbe.',
      no_email: 'du',
      title: 'Afmeld emails om påmindelse',
      title_unsubscribed: 'Færdig!',
      downloaded: {
        body: 'Forstået. Du kan framelde påmindelser om udløb af overførsler for filer, der allerede er blevet downloadet. Det ændrer ikke på, at vi fortsat sender dig påmindelser i de tilfælde, hvor folk endnu ikke har downloadet indholdet.',
        cta: 'Frameld',
        title:
          '"Mine filer er blevet downloadet. Jeg behøver ikke e-mails om overførsler, der snart udløber"',
      },
      not_downloaded: {
        body: 'Intet problem. Du kan framelde påmindelser om udløb af overførsler – også for de overførsler, hvor modtageren endnu ikke har downloadet dine filer.',
        cta: 'Frameld',
        title:
          'Ønsker du ikke flere e-mails om overførsler, der snart udløber?',
      },
      pro: {
        body_1:
          'Det er helt i orden. Du kan framelde disse påmindelser. Du vil stadig kunne se, hvornår overførsler udløber i din overførselsoversigt, og når som helst ændre deres udløbsdatoer.',
        body_2:
          'Pst! Har du skiftet mening, eller sidder du fast et sted? Det klarer vi. Du kan fange os på <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a>.',
        cta: 'Frameld',
        title:
          'Ønsker du ikke flere e-mails om overførsler, der snart udløber?',
      },
    },
    about: {
      legal: {
        actionbar: {
          text: 'Er du sikker på, at du vil rydde dine cookies?',
        },
      },
    },
    about_plus: {
      checklist: {
        title: 'Opgrader til Pro i dag for %{currency}%{price} om måneden',
      },
    },
    advertise: {
      gallery: {
        preview: 'Forhåndsvisning',
      },
      guidelines: {
        advert_static: {
          title: 'Statisk tapet',
        },
      },
    },
    billinginfo: {
      pagename: 'Faktureringsoplysninger',
    },
    help: {
      button_all_answers: 'Flere svar',
      page_title: 'Hurtig hjælp',
      read_more: 'Læs mere',
      search_button: 'Søg',
      search_placeholder: 'Hvad kan vi hjælpe dig med?',
    },
    payment_redirect_loader: {
      title: 'Just a moment',
      subtitle: 'Please resist the temptation to refresh or close this page',
    },
    payment_pending: {
      order_in_progress: 'Indlæser ...',
    },
    payment_update: {
      bancontact: {
        info: 'Bemærk – Bancontact opkræver et engangsgebyr på 0,50 EUR for at verificere dine oplysninger.',
      },
      confirm_update: 'Bekræft',
      ideal: {
        info: 'Bemærk – iDEAL opkræver et engangsgebyr på 0,01 EUR for at verificere dine oplysninger.',
      },
      info: 'Bemærk – iDEAL opkræver et engangsgebyr på 0,01 EUR for verificering af dine oplysninger.',
      sofort: {
        info: 'Bemærk – SOFORT opkræver et engangsgebyr på 1 EUR for at verificere dine oplysninger.',
      },
      title: 'Opdater betalingsoplysninger',
      update_in_progress: 'Opdaterer dine oplysninger...',
    },
    sign_in: {
      account: 'Har du ikke en konto?',
      upgrade: 'Opgrader til WeTransfer Pro',
    },
    signin: {
      account_cta: 'Opret en konto',
      account_item_1: 'Send op til %{size_limit}',
      account_item_2: 'Håndter overførsler',
      account_item_3: 'Gem op til %{storage_limit}',
      account_subtitle: 'Gratis',
      plus_cta: 'Få WeTransfer Pro',
      plus_item_1: 'Send op til %{size_limit}',
      plus_item_2: 'Håndter overførsler',
      plus_item_3: 'Gem op til %{storage_limit}',
      plus_item_4: 'Dine egne baggrunde',
      plus_item_5: 'En personlig URL',
      plus_item_6: 'Beskyt overførsler med en adgangskode',
      plus_month: '/måned',
    },
    teams: {
      invitee: {
        action_cancel_invite: 'Afvis invitation',
      },
      invitees: {
        title: 'Inviteret - venter på svar',
      },
      member: {
        action_demote: 'Fjern som admin',
        action_promote: 'Gør til admin',
        action_revoke: 'Fjern fra team',
      },
      members: {
        title: 'I dit team',
      },
      no_access: {
        description: 'Vi siger til, når den er klar. ',
        title: 'Hov, den her funktion er vist stadig hemmelig. ',
      },
      subtitle: {
        members: {
          one: '%{count} medlem',
          other: '%{count} medlemmer',
        },
        pending: '%{pendingCount} inviteret',
      },
      tip: {
        button: 'Få mere at vide',
        subtitle:
          'Med vores helt nye funktion Pro for Teams har vi gjort den bedste WeTransfer-oplevelse endnu bedre! Tilføj nye medlemmer gratis. Brug den superenkle formular herunder for at få gang i teamet – når de godkender din invitation, er I klar!',
        title: 'Et team indeholder flere end bare mig...',
      },
      title: 'Team',
    },
    transfer_progress: {
      meta: {
        expires_in: 'Udløber om %{expiry}.',
      },
      recipients: 'Sender til',
      upsell: {
        benefit_one: 'Se, hvornår dine filer blev downloadet',
        benefit_three: 'Gennemgå og send dine gamle overførsler igen',
        benefit_two: 'Se, hvem der downloadede dine filer',
        button: {
          action: 'Fortæl mig mere',
          cancel: 'Nej tak',
        },
        heading:
          'Hold let og enkelt styr på dine overførsler med WeTransfer Pro',
        title: 'Dine overførselsoplysninger',
      },
    },
    transferReceived: {
      'empty-description':
        'Her finder du alle de overførsler, der er sendt til dig – bare rolig, det går ikke ud over din lagringsplads',
      'empty-title': 'Hold styr på dine overførsler',
      empty: {
        description:
          'Her finder du alle de overførsler, der er sendt til din e-mailadresse eller er uploadet til dig. De optager ikke noget af din lagerplads.',
      },
      banner: {
        freeUser: {
          text: 'Opgrader for at gøre det let at modtage. Få en brugerdefineret URL <strong>yourname.wetransfer.com</strong> og en branded side til overførsler.',
          link: 'Læs mere',
          cta: 'Opgradér',
        },
        paidUser: {
          withUrl: {
            text: 'Alle kan sende dig 200 GB overførsler på <strong>%{personalisedUrl}</strong>',
            cta: 'Kopiér webadresse',
          },
          withoutUrl: {
            text: 'Indstil din URL <strong>yourname.wetransfer.com</strong>, og alle kan overføre filer til dig.',
            link: 'Læs mere',
            cta: 'Gå til branding',
          },
        },
      },
    },
    unsubscribeonboarding: {
      action: 'Afmeld',
      back: 'Tilbage til WeTransfer',
      contact:
        'Hvis du sidder fast i noget, kan du altid kontakte os på <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a> — det er helt i orden.',
      done: 'Sådan!',
      message:
        'Du kan afmelde dig fra vores introduktionsmails — men bare rolig, du får stadig besked om alt det vigtigste.',
      title: 'Er din indbakke ved at være fuld?',
    },
    userinfo: {
      pagename: 'Personlige oplysninger',
    },
    free_onboarding: {
      close: 'Luk',
      finish_tour: 'Færdig',
      next: 'Næste',
      send_files: 'Bare fortsæt til send filer',
      start_tour: 'Se, hvad vi mere kan tilbyde',
      step_one: {
        body_1:
          'Nu hvor du har bekræftet e-mailadressen til din konto, behøver du ikke at gøre det, hver gang du sender filer. Det er slut med bekræftelseskoder!',
        body_2:
          'Hold styr på dine sendte og modtagne filer på ét sted. Se, hvor mange gange dine filer bliver downloadet. Gensend, videresend eller slet overførsler med et klik.',
        header_1: 'Bekræftet en gang for alle',
        header_2: 'Administrer dine overførsler',
        subtitle:
          'Sig farvel til bekræftelseskoder og mistede downloadlinks. Med din nye konto kan du hurtigt og nemt sende store filer – helt gratis.',
        title_1: 'Send filer <strong>på dine præmisser</strong>',
        title_2: 'med WeTransfer',
      },
      step_three: {
        body_1:
          'Gem det, der inspirerer dig, på ét sted – fra videoer på din telefon til links på dit skrivebord. Begyndt med at åbne Collect med starteren (den i øverste venstre hjørne), eller brug linket nedenfor.',
        cta: 'Gå til Collect',
        title_1: '<strong>Gem inspiration</strong> på farten',
        title_2: 'med Collect',
      },
      step_two: {
        body_1:
          'Pitch dine idéer. Vis, hvor langt du er. Hold dig opdateret. Uden nogensinde igen at formatere en slide. Begynd med at åbne Paste med starteren (den i øverste venstre hjørne), eller brug linket nedenfor.',
        cta: 'Gå til Paste',
        title_1: 'Skab <strong>slides på få sekunder</strong>',
        title_2: 'med Paste®',
      },
    },
    modal: {
      portals_intro: {
        cta: 'Prøv portals',
        pill: 'Helt ny funktion',
        text: 'Vi præsenterer <strong>portals</strong>, en hurtigere vej til den endelige godkendelse, du mangler. Invitér kunder og samarbejdspartnere til at se og vælge deres favoritter—uden at skulle downloade filer.',
        title: 'Del arbejde. Få feedback. Alt på samme sted.',
      },
    },
    not_found: {
      body: 'Gå tilbage til <a href="https://wetransfer.com/">wetransfer.com</a>, eller trøst dig med et par <a href="https://wepresent.wetransfer.com/">gode ting, vi har skrevet</a>.',
      image_alt: 'Der opstod en fejl',
      title: 'Den side kan vi desværre ikke finde.',
    },
    password_and_security: {
      title: 'Adgangskode og sikkerhed',
      'two-factor-authentication': {
        description: {
          enabled: 'Fra %{date}',
        },
        disable: 'Deaktiver',
        done: 'Udført',
        enable: 'Aktivér',
        get_recovery_codes: 'Hent gendannelseskoder',
        next_step: 'Næste',
        recovery_code_action: 'Generer nye koder',
        recovery_code_keep_safe:
          'Hver kode kan kun bruges én gang, men du kan altid hente flere, hvis du får brug for det.',
        recovery_code_need_more:
          'Skal du bruge flere gendannelseskoder? Du kan altid generere nye koder – bare husk, at de nye koder gør de gamle ugyldige.',
        recovery_code_title: 'Dine gendannelseskoder',
        require_password_action: 'Angiv',
        require_password_text: 'Indtast din adgangskode for at fortætte',
        step_one_action: {
          app_store: 'Download fra App Store',
          google_play: 'Hent den på Google Play',
        },
        step_one_label: 'Trin 1 (af 3)',
        step_one_text:
          'Du skal bruge en godkendelsesapp til din telefon. Hvis du allerede har Google Authenticator (eller en tilsvarende app), kan du gå videre.',
        step_one_title: 'Download Google Authenticator',
        step_three_label: 'Trin 3 (du er klar!)',
        step_three_text:
          'Hvis du skal logge på og ikke har din telefon på dig (det kan faktisk ske), kan du bruge en af disse gendannelseskoder. Vi kan ikke passe på koderne for dig og kan heller ikke vise dig dem igen, så husk dem nu – og pas lige så godt på dem, som pinkoden til dit dankort.',
        step_three_text_2:
          'Opbevar disse koder lige så sikkert som koden til din netbank! Hver kode kan kun bruges én gang.',
        step_three_title: 'Gem gendannelseskoder',
        step_two_form: {
          error: 'Hov, koden er forkert eller udløbet',
          label: 'Godkendelseskode',
        },
        step_two_label: 'Trin 2 (du er halvvejs)',
        step_two_text:
          'Brug din godkendelsesapp til at scanne koden. Appen vil generere en sekscifret godkendelseskode – indtast godkendelseskoden nedenfor.',
        step_two_text_mobile:
          'Angiv denne nøgle i din godkendelsesapp. Appen vil generere en sekscifret godkendelseskode – indtast koden nedenfor.',
        step_two_title: 'Scan kode',
        step_two_title_mobile: 'Angiv nøgle',
        text: {
          protect_account:
            'Brug din telefon til at øge sikkerheden på din konto.',
        },
        title: 'Totrinsgodkendelse',
      },
    },
    'payment-cancellation': {
      bundle: {
        title: 'Få alt det bedste fra Paste® og Collect',
      },
      cta: 'Nej, jeg ønsker at forblive Pro',
      'cta-2': 'Opsig mit abonnement',
      disclaimer: {
        collect: 'Din lagerplads vil gå fra 200 GB til 5 GB i Collect',
        paste:
          'Du vil gå fra at have ubegrænsede sæt i Paste® til kun at have 3',
        'team-member':
          'Du vil blive fjernet fra %{currentTeam} på WeTransfer Pro.',
        teams:
          'Dit team på %{amountOfMembers} vil blive fjernet fra %{currentTeam} i WeTransfer Pro',
        title:
          'Når dit igangværende abonnement slutter på <strong>%{date}</strong>:',
        'transfer-expiry':
          'Vil dine eksisterende overførsler blive slettet efter 28 dage',
        'transfer-team-member':
          'Du kan ikke sende og modtage overførsler som en del af teamet, og du kan ikke administrere eksisterende teamoverførsler.',
      },
      'password-expiry': {
        title: 'Beskyt overførsler med kodeord og angiv en udløbsdato',
      },
      personalization: {
        title: 'Lav din egen personlige WeTransfer-side',
      },
      portals: {
        text: 'Med %{planName} kan du bruge <a href="%{href}" target="_blank">portaler</a> til at dele arbejde, som kunderne kan gennemgå – downloads er ikke nødvendige.',
        title: 'Del jeres arbejde og få feedback på ét og samme sted',
      },
      'stay-pro': 'Bevar abonnement',
      'storage-limit': {
        title: 'Nyd godt af %{storage_limit_pro} lagerplads per person.',
      },
      subtitle:
        'Hvis du afmelder dig nu, vil du fra %{date} ikke længere kunne:',
      teams: {
        'individual-text':
          '<a href="%{href}" target="_blank">Inviter teammedlemmer</a> til at sende, modtage og administrere overførsler sammen – eller arbejd alene helt gratis.',
        'team-member-text':
          'Du vil blive fjernet fra dit team, og du vil ikke længere kunne sende, modtage eller administrere overførsler sammen.',
        'team-owner-text':
          'Du har <a href="%{href}" target="_blank">%{amountOfMembers} teammedlemmer</a>, som ikke længere vil kunne sende, modtage og holde styr på overførsler sammen.',
        title: 'Arbejd sammen om de store idéer',
      },
      title: 'Er du virkelig klar til at slippe %{planName}?',
      'transfer-limit': {
        text: 'I øjeblikket kan du sende og modtage større overførsler – langt flere end de gratis %{transfer_limit_free}.',
        title: 'Sende 100 gange større overførsler',
      },
      'transfer-unlimited': {
        text: 'Du kan sende (og modtage) overførsler uden begrænsninger på filstørrelsen – det er uendeligt meget mere end ved gratisversionens grænse på %{transfer_limit_free}.',
        title: 'Sende overførsler i alle størrelser',
      },
    },
    pricing: {
      pro: {
        per_person: 'pr. person',
      },
    },
    pricing_panel: {
      cta: {
        create_account: 'Opret konto',
        current_plan: 'Nuværende abonnement',
        sign_up: 'Tilmeld dig',
        switch_premium: 'Skift til Premium',
        switch_pro: 'Skift til Pro',
        upgrade: 'Opgradér',
      },
      faq: {
        answers: {
          answer_1:
            'Du kan begynde at bruge WeTransfer Pro eller WeTransfer Premium, så snart du har betalt. Vi sender dig også en bekræftelses-email, som har din betalte faktura vedhæftet.<br /><br />\n\nNår du er i gang, vil du kunne sende større overførsler, begynde at bruge portaler, og lave din helt egen WeTransfer-side med det samme. Hvis du overførsler fra tidligere, som blev sendt mens du stadig havde gratisversionen, vil du også frit kunne ændre udløbsdatoerne på disse.',
          answer_2:
            'Når du bruger WeTransfer, kan alle og enhver downloade dine filer - de behøver hverken logge ind eller tilmelde sig. De skal acceptere vores servicebetingelser, og vi beder dem måske om at acceptere cookies, men det er også dét!<br /><br /> \n\nHvis du vil dele arbejde eller samarbejde i portaler (WeTransfers seneste funktion), behøver dine kunder og samarbejdspartnere ikke tilmelde sig for at kunne se og vælge filer, skrive kommentarer, godkende, eller downloade filer. Du behøver kun tilføje folk som teammedlemmer under dit Pro eller Premium-abonnement, hvis de skal kunne tilføje rettelser/gennemgange og lave portaler med dig.',
          answer_3:
            'Med et Pro- eller Premiumabonnement kan du lave din helt egen WeTransfer-side, hvor alle og enhver kan sende dig filer op til den grænse for filstørrelse, der hører til dit abonnement. Med andre ord kan du modtage de store filer, du har brug for, fra kunder og samarbejdspartnere, uden at de behøver have en konto - de skal blot bruge din sides URL. (Dog kan vi bede dem om at bekræfte deres e-mailadresse for at beskytte dig mod "udenlandske prinser", som "gerne vil sende dig penge").',
          answer_4:
            'Det første, du skal gøre, er at tilmelde dig WeTransfer Pro eller WeTransfer Premium - du kan ikke tilføje teammedlemmer i den gratis version. Uanset hvilket abonnement, du vælger, vil dine teammedlemmer nyde godt af de samme fordele (du kan altså ikke have fx Premium til dig selv og Pro til dine teammedlemmer).Teammedlemmer vil kunne sende og modtage større overførsler fra din WeTransfer-side samt holde styr på overførsler fra en fælles oversigt.<br /><br /> \n\nNår du har tilmeldt dig det abonnement, der passer dit team bedst, kan du invitere lige så mange teammedlemmer, som du vil, fra indstillingerne for teamstyring. Du kan tilføje og fjerne teammedlemmer når som helst, så længe dit abonnement er aktivt.',
          answer_5:
            'Vi accepterer PayPal såvel som kreditkort fra større udbydere, såsom Visa, Mastercard, og American Express. I visse lande understøtter vi desuden andre online betalingssystemer.<br /><br /> \n\nVi accepterer ikke bankoverførsler, da man skal oprette en årlig eller månedlig betalingsaftale til sit abonnement. (Vi sender dig en e-mail inden den første opkrævning, så den ikke kommer som en overraskelse).',
          answer_6:
            'Hvis du ikke har ubegrænset lagerplads med WeTransfer Premium, vil du være nødt til enten at rydde noget plads ved at slette nogle af dine sendte overførsler, eller opgradere dit abonnement. Du vil ikke kunne sende eller modtage nye overførsler, før du gør dette.<br /><br /> \n\nHvis du bruger WeTransfer gratis, slettes alle dine overførsler på op til 2 GB automatisk efter 7 dage. Så bare rolig, du kan slet ikke overskride din lagerpladsgrænse.',
          answer_6_variant_asterisk:
            'Du skal frigøre lagerplads ved at slette nogle af dine sendte overførsler eller opgradere din plan. Indtil du gør det, kan du ikke sende nye overførsler. <br /><br />\n\nHvis du har et Premium-abonnement og når op på 5 TB, kan du kontakte vores supportteam og anmode om mere lagerplads op til en maksimal årlig grænse på 15 TB. <br /><br />\n\nHvis du bruger WeTransfer gratis, bliver alle dine sendte overførsler på op til 2 GB automatisk slettet efter 7 dage. Så bare rolig, det er ikke muligt for dig at overskride din lagergrænse.',
          answer_6_variant_limited_storage:
            'Du bliver nødt til at frigøre noget lagerplads ved at slette nogle af dine sendte overførsler eller opgradere dit abonnement (medmindre du har et Premium-abonnement). Indtil du gør det, kan du ikke sende nye overførsler. <br /><br />\n\nHvis du bruger WeTransfer gratis, bliver alle dine sendte overførsler på op til 2 GB automatisk slettet efter 7 dage. Så bare rolig, det er ikke muligt for dig at overskride din lagergrænse.',
          answer_7:
            'Dit abonnement fornys automatisk (vi sender dig en e-mail inden det sker for første gang), men du kan afmelde dig til enhver tid.<br /><br /> \n\nFor at skifte til WeTransfers gratisversion, skal du bare gå ind på dine <strong> konto-</strong>indstillinger og annullere dit abonnement. Du (og eventuelle teammedlemmer) vil stadig kunne bruge dit Pro- eller Premiumabonnement frem til udløbet af den indeværende faktureringsperiode.',
          answer_8:
            'Millioner af mennesker verden over sætter deres lid til WeTransfer og vores produktkatalog, når deres idéer skal frem i verden. Hver måned deler 80 millioner mennesker 2 milliarder filer, alene på vores fildelingsplatform.<br /><br /> \n\nFor at sikre dine idéer mod angreb eller misbrug, krypteres dine filer, når de overføres (TLS) og når de opbevares (AES-256). Når dine filer opbevares, kan de kun tilgås via de unikke links, som sendes til afsender og modtager.',
        },
        questions: {
          question_1: 'Hvad sker der, efter jeg tilmelder mig og betaler?',
          question_2: 'Skal mine modtagere også tilmelde sig?',
          question_3: 'Kan jeg modtage større filer? ',
          question_4: 'Hvordan tilføjer (og fjerner) jeg teammedlemmer?',
          question_5: 'Hvilke betalingsmetoder kan jeg bruge?',
          question_6:
            'Hvad sker der, hvis jeg overskrider min grænse for lagerplads?',
          question_7: 'Hvordan afmelder jeg mig?',
          question_8: 'Er WeTransfer pålideligt? Hvor sikkert er det?',
        },
        title: 'Ofte stillede spørgsmål',
      },
      feature_table: {
        branding: {
          features: {
            advertising: 'Reklame (og kunst)',
            custom: 'Upload dit eget',
            feature_1: 'Personlig WeTransfer-side',
            feature_2: 'Tapet-baggrunde',
            feature_3: 'Personligt tilpassede WeTransfer e-mails',
          },
          title: 'Vis dit brand frem',
        },
        bundle: {
          collect: {
            storage: '%{collectStorageLimit} lagerplads',
            title: 'Collect fra WeTransfer',
          },
          paste: {
            limited_decks:
              'Op til %{pasteDecksLimit} dæk med Pastes standardlogo',
            title: 'Paste® fra WeTransfer',
            unlimited_decks: 'Ubegrænsede dæk med din egen branding',
          },
          title: 'Fuldend din kreative værktøjskasse',
        },
        expiry: 'Overførsler udløber efter %{days} dage',
        extra_storage: 'Ekstra %{storageLimit} pr. person',
        monthly_price: '%{price} om måneden pr. person',
        portals: {
          features: {
            feature_1: 'Portaler',
            feature_2: 'Gennemgange',
            feature_3: 'Kundebranding',
          },
          title:
            'Del dit arbejde, så du kan få feedback, og det kan blive godkendt',
        },
        security: {
          features: {
            feature_1: 'Personligt tilpassede udløbsdatoer',
            feature_2: 'Overførsler med kodeordsbeskyttelse',
            feature_3: 'Datakryptering',
            feature_4: 'Tofaktorgodkendelse',
          },
          title: 'Gør dine overførsler sikre',
        },
        storage_limit: '%{storageLimit} pr. person',
        teams: {
          features: {
            feature_1: 'Invitér team-medlemmer',
            feature_2: 'Delt oversigt over overførsler',
            feature_3: 'Delt lagerplads',
            feature_4: 'Delt branding',
          },
          title: 'Aflever arbejde som et samlet team',
          subtext: {
            text: 'Understøttes kun, hvis du køber et abonnement fra vores website.',
            learn_more: 'Læs mere',
          },
        },
        tooltips: {
          tooltip_1:
            'Alle overførsler, som du sender, tæller som en del af din lagerplads',
          tooltip_10:
            'Du kan sende og opbevare filer sikkert med TLS og AES-256-kryptering',
          tooltip_11:
            'Hold øje med downloads, og hold styr på jeres overførsler sammen',
          tooltip_12:
            'Vis jeres (sam-)arbejde frem med tapeter og e-mails med jeres brand',
          tooltip_13:
            'Paste er et præsentationsværktøj, som designer dæk for dig med passende farver, linjemæssig justering og layout',
          tooltip_14:
            'Med Collect kan du gemme og holde styr på billeder, videoer, musik og links på tværs af enheder',
          tooltip_2:
            'Folk kan downloade dine filer uden at skulle logge ind eller tilmelde sig',
          tooltip_3:
            'Hold øje med, hvem der har (eller ikke har) downloadet dine filer',
          tooltip_4:
            'Hold styr på dit arbejde for hver eneste kunde og projekt',
          tooltip_5:
            'Invitér kunder til at se og vælge filer, kommentere og godkende - uden at de skal downloade noget som helst',
          tooltip_6: 'Føj logo og titel til dine portaler for hver kunde',
          tooltip_7:
            'Din WeTransfer-side er stedet, hvor folk downloader dine filer og sender dig overførsler inden for dit abonnements størrelsesbegrænsning',
          tooltip_8:
            'Tapeter er de videoer og billeder, du ser i baggrunden, når du sender og modtager filer på wetransfer.com',
          tooltip_9:
            'Hold da op, vi troede ikke, at der var nogen, der faktisk læste disse tekster - du har lige gjort vores fordomme til skamme! Skærmklip kan blive retweetet af @WeTransfer',
        },
        transfer_classic: {
          features: {
            feature_1: 'Begrænsning på overførselsstørrelse',
            feature_2: 'Lagerplads',
            feature_3: 'Downloads uden en konto',
            feature_4: 'Spor downloads',
            feature_5: 'iOS-app',
          },
          title: 'Send store filer',
        },
        unlimited: 'Ubegrænset',
        yearly_price: '%{price} om året pr. person.',
      },
      header: {
        subtitle:
          'Uanset om du sender store filer i arbejdsøjemed, eller om det bare er for at dele sjove ting, kan du sikre fremdrift i dine projekter med WeTransfer.',
        title: {
          english_1: 'Du har ideerne,',
          english_2: 'vi har løsningerne',
          general: 'Abonnementer og priser',
        },
      },
      plans: {
        billing: {
          discount: 'Spar %{percentage} (jep, den er god nok)',
          monthly: 'Månedlig fakturering',
          yearly: 'Årlig fakturering',
        },
        free: {
          subtitle: 'Send filer en gang imellem',
          title: 'Gratis',
          usp: {
            feature_1: 'Send op til %{transferLimit}',
            feature_2: 'Du behøver ikke bekræfte overførsler',
          },
        },
        premium: {
          subtitle: 'Del arbejde uden begrænsninger',
          title: 'Premium',
          usp: {
            feature_1: 'Ingen begrænsning på overførselsstørrelse',
            feature_2: 'Ubegrænset lagerplads',
            feature_2_subtitle:
              '*Den oprindelige grænse er %{storageLimit} med mulighed for at tilføje ekstra lagerplads ved anmodning. Der gælder en maksimal årlig grænse på %{annualStorageLimit}. Du kan finde flere oplysninger i vores <a href="/legal/terms" data-route-type="premium" target="_blank">servicevilkår</a>.',
            feature_3: 'Ubegrænsede portaler og gennemgangs-/rettelsesrunder',
          },
        },
        pro: {
          subtitle: 'Send meget store filer regelmæssigt',
          title: 'Pro',
          usp: {
            feature_1: 'Send, og modtag op til %{transferLimit}',
            feature_2: '%{storageLimit} lagerplads per person',
            feature_3:
              '%{portalsLimit} portal, ubegrænsede gennemgangs-/rettelsesrunder',
          },
        },
        tagline: {
          free: 'ingen penge, intet problem',
          monthly: 'pr. måned pr. person',
          yearly: 'pr. år pr. person',
          per_person_monthly: 'pr. person, faktureret månedligt',
          per_person_yearly: 'pr. person, faktureret årligt',
          tax_included: 'inklusive afgift',
        },
        title: 'Vælg dit abonnement',
        month: 'måned',
      },
      skip_link: 'Spring til flere funktioner',
    },
    pro_classic: {
      hero: {
        cta_1: 'Læs mere',
      },
    },
    splashpage: {
      bundle: {
        title_new: 'Du har idéerne, vi har abonnementerne',
      },
      cta: 'Jeg vil bare sende filer',
      free_panel: {
        cta: 'Opret konto',
      },
      plan: {
        free: {
          feature_1: 'Send op til <strong>%{transfer_limit}</strong>',
          feature_2: 'Slut med at bekræfte overførsler',
          subtitle_new: 'Til de afslappede fil-sendere',
          title: 'Gratis',
        },
        pro: {
          feature_1: 'Send og modtag op til <strong>%{transfer_limit}</strong>',
          feature_2: 'Bestem, hvornår overførsler udløber',
          feature_5: '1 TB lagerplads pr. person',
          subtitle_new: 'Til professionelle og teams',
          title: 'Pro',
        },
      },
      reciever: {
        free: {
          cta: 'Tilmeld dig nu',
          descripttion: 'Hold styr på dine overførsler',
          feature_1: 'Send op til 2 GB',
          feature_2: 'Modtag overførsler i én oversigt',
          title: 'Gratis',
        },
        pro: {
          cta: 'Få mere at vide',
          descripttion: 'Få det bedste, WeTransfer har at byde på',
          feature_1: 'Send og modtag op til %{transfer_size}',
          feature_2: '%{storage_size} lagerplads til overførsler pr. person',
          feature_3: 'Send overførsler med brugerdefinerede indstillinger',
          title: 'Pro',
        },
        title: 'Sørg for, at overførsler ikke går tabt i din indbakke.',
      },
      title: 'Få det maksimale ud af det nye WeTransfer',
    },
    teamsettings: {
      invite: {
        cta: 'Inviter team',
        pagename: 'Inviter team',
      },
      manage: {
        cta: 'Administrer team',
      },
      members:
        'Du har %{amountOfMembers} teammedlemmer. <a href="%{href}">%{cta}</a>',
      no_members: 'Lige nu er der kun dig! <a href="%{href}">%{cta}</a>',
      settings: {
        pagename: 'Teamindstillinger',
      },
    },
    universal_onboarding: {
      team_feature: {
        subtitle: 'Gå sammen og overfør sammen',
        context:
          'Send og modtag overførsler som et team med delt lagring, branding og adgang til hinandens overførsler.',
        invite_team: 'Inviter team',
        dismiss: 'Måske lidt senere',
      },
      feature_highlight: {
        free_context:
          'Nu kan du holde styr på sendte og modtagne overførsler i en enkel oversigt. Få det at vide i samme øjeblik, filer bliver downloadet. Gensend, videresend, eller download dine overførsler med et klik. Så nemt er det',
        free_subtitle: 'Alle dine overførsler - samlet ét sted',
        paste_collect_link:
          'Gå til <a href="%{pasteUrl}" rel="external">%{pasteName}</a> eller <a href="%{collectUrl}" rel="external">%{collectName}</a>',
        premium_context:
          'Nu kan du sende overførsler af en hvilken som helst størrelse og oprette din egen <b>WeTransfer-side</b>, så du kan tilpasse, hvad folk ser, når de downloader dine filer. Er du klar til at vælge din URL og dine tapeter?',
        premium_cta: 'Opret side',
        premium_dismiss: 'Måske lidt senere',
        premium_subtitle: 'Opsæt din WeTransfer-side',
        premium_team_context:
          'Nu kan du sende og modtage overførsler på en hvilken som helst størrelse fra dit teams personlige WeTransfer-side.',
        pro_context:
          'Nu kan du sende op til %{transfer_limit} på en gang og oprette din egen <b>WeTransfer-side</b>, så du kan tilpasse, hvad folk ser, når de downloader dine filer. Er du klar til at vælge din URL og dine tapeter?',
        pro_team_context:
          'Nu kan du sende og modtage %{transfer_limit} overførsler fra dit teams <b>personlige WeTransfer-side</b>.',
        send_cta: 'Gå til send filer',
        team_subtitle: 'Aflever kreativt arbejde som en gruppe',
      },
      marketing: {
        context:
          'Nu hvor vi ved lidt om dig, vil vi gerne fortælle dig lidt om os. Vil du høre historier om kreativitet og de seneste WeTransfer-nyheder?',
        image_alt_text:
          'Eksempel på e-mailindhold, inklusive nye produktegenskaber, industrirapporter og WePresent-artikler, som fortæller historier om kreativitet.',
        opt_in: 'Ja tak',
        opt_out: 'Nej tak',
        unsubscribe:
          'Du kan altid afmelde dig senere - det er helt i orden med os.',
      },
      welcome: {
        context: 'Hvis vi lærer dig at kende, kan vi forbedre vores service',
        cta: 'Fortsæt',
        dismiss: 'Spring over',
        dropdown_options: {
          architecture: 'Arkitektur / Byggeri',
          data: 'Data / Finans / Jura',
          design: 'Design/illustration',
          education: 'Uddannelse / Kurser',
          marketing: 'Markedsføring/PR',
          music: 'Musik / Lyd',
          other: 'Andet (med stolthed)',
          photography: 'Fotografi',
          product: 'Produkt / Software',
          sales: 'Salg / Kunderelationer',
          video: 'Video/animation',
        },
        free_tier_title: 'Velkommen til WeTransfer, %{name}!',
        placeholder: 'Hmmm, lad os se...',
        question:
          'Allerførst kunne vi tænke os at høre, hvilken sektor du tilhører?',
        team_title: 'Du er med i teamet, %{name}!',
        tier_title: 'Velkommen til WeTransfer %{tier},%{name}!',
        data_opt_in: {
          checkbox_label:
            'Lad WeTransfer bruge data, du deler, til at vise dig skræddersyede annoncer på og uden for vores websites.',
          tooltip_anchor: 'Hvad betyder det?',
          tooltip: {
            title: 'Hvordan bruger WeTransfer mine data?',
            p1: 'Vi bruger din e-mailadresse til at vise dig (og andre som dig) WeTransfer-annoncer på de websites, du besøger, såsom sociale medier.',
            p2: 'Vi bruger også dit arbejdsfelt til at give dig en bedre oplevelse på vores websites.',
            p3: 'De data, du vælger at dele med os, forbliver sikre til enhver tid.',
            button: 'Forstået',
          },
        },
      },
    },
    workspace_bar: {
      tooltip_text: 'Tilføj andre til dit arbejdsområde',
      workspace: 'Arbejdsområde',
      manage_workspace: 'Administrer arbejdsområde',
    },
  },
  exception: {
    activate_subscription_exception:
      'Nå, der gik noget galt - prøv igen, eller kontakt vores <a href="https://wetransfer.zendesk.com" rel="external">supportcenter</a>',
    complete_payment_exception:
      'Hmm, noget gik galt - prøv igen, eller kontakt os via vores <a href="https://wetransfer.zendesk.com" rel="external">helpcenter</a>',
    retrieve_checkout_exception:
      'Nå, noget gik galt - prøv igen eller kontakt vores <a href="https://wetransfer.zendesk.com" rel="external">supportcenter</a>',
    source_id_error:
      'Vi kunne desværre ikke behandle denne anmodning – prøv igen',
    three_d_secure: 'Vi understøtter ikke 3D Secure-kort.',
    something_went_wrong:
      'Hmm, der gik noget galt - prøv igen, eller kontakt os via vores <a href="https://wetransfer.zendesk.com" rel="external">helpcenter</a>',
    signin_no_data_exception:
      'Hmm, der gik noget galt - kontrollér dit brugernavn og din adgangskode, og prøv igen',
    signin_exception: 'Desværre, vi kunne ikke logge dig på – prøv igen',
    signout_exception:
      'Hmm, det ser ud til, at vi ikke kunne logge dig af. Mystisk. Prøv at opdatere siden for at kontrollere, om du stadig er logget på.',
    signup_account_error:
      'Hmm, der gik et eller andet galt, da du loggede på – kontrollér dine oplysninger, og prøv igen',
    retrieve_account_exception:
      'Hmm, der gik noget galt. Vi beklager at måtte spørge dig, men vil du være venligt at prøve igen?',
    update_account_error:
      'Beklager - vi kunne ikke opdatere dine kontooplysninger. Vil du prøve igen?',
    retrieve_subscription_exception:
      'Vi kunne ikke finde dine betalingsoplysninger - prøv venligst igen',
    update_subscription_exception:
      'Vi kunne ikke finde dine betalingsoplysninger - prøv igen, eller kontakt os via vores <a href="https://wetransfer.zendesk.com" rel="external">helpcenter</a>',
    autorenewal_not_supported:
      'Automatisk fornyelse understøttes ikke for denne konto',
    email_background_upload_validation_error:
      'Filen er for stor eller ikke i png- eller jpg-format - prøv et andet billede',
    email_background_upload_validation_error_videos:
      'Filen er for stor eller ikke i png- eller jpg-format - prøv et andet billede',
    update_password_exception:
      'Desværre, vi kunne ikke opdatere din adgangskode – prøv igen',
    retrieve_device_exception:
      'Vi kunne ikke finde nogen tilsluttede enheder. Ikke en eneste! Prøv igen.',
    remove_device_exception: 'Vi kunne ikke fjerne enheden',
    renew_subscription_exception:
      'Vi kunne ikke forny din konto – prøv igen senere',
    invoices_retrieve_exception:
      'Vi kunne ikke finde dine kvitteringer – prøv igen',
    invoice_download_exception:
      'Vi kunne ikke downloade kvitteringen – prøv igen',
    image_not_valid: 'Hmm, det ser ud til, at billedet ikke kan uploades',
    update_profile_error: 'Hmm, vi kunne ikke opdatere din profil – prøv igen',
    retrieve_profile_exception:
      'Vi kunne ikke finde dine profilindstillinger – prøv igen',
    s3_exception: 'Hmm, der gik noget galt under indlæsningen – prøv igen',
    file_size_limit_reached:
      'Større er ikke altid bedre – prøv at uploade et billede på 3 MB eller derunder',
    retrieve_transferlist_exception:
      'Vi kunne ikke finde din liste over overførsler',
    retrieve_transfer_exception:
      'Vi kunne ikke finde dine overførselsoplysninger',
    delete_transfer_exception: 'Vi kunne ikke slette overførslen',
    delete_transfers_exception: 'Vi kunne ikke slette overførslerne',
    update_expiry_exception: 'Vi kunne ikke opdatere datoen for udløb.',
    add_contact_exception: 'Vi kunne ikke tilføje denne kontakt',
    complete_last_order_exception: 'Vi kunne ikke gennemføre din ordre',
    edit_contact_exception: 'Vi kunne ikke opdatere denne kontakt',
    remove_contact_exception: 'Vi kunne ikke slette denne kontakt',
    request_password_reset_exception:
      'Desværre, vi kunne ikke behandle anmodningen om nulstilling — prøv venligst igen',
    request_password_reset_no_user:
      'Vi kan ikke genkende e-mailadressen - tjek en gang til, og prøv igen',
    reset_password_error:
      'Der gik noget galt under nulstilling af adgangskoden — prøv igen',
    reset_password_exception:
      'Desværre, vi kunne ikke nulstille adgangskoden — prøv venligst igen',
    reset_password_token_invalid:
      'Hmm, nulstillings-linket fungerede ikke — følg den vejledning, vi har sendt dig, eller start igen',
    retrieve_last_order_exception: 'Vi kunne ikke finde din ordre',
    retrieve_ternot_exception:
      'Hmm, vi har problemer med at finde din overførsel – prøv igen',
    signin_invalid_credentials:
      'Denne e-mailadresse og adgangskode passer ikke sammen — tjek endnu en gang, og prøv igen',
    unsubscribe_expiration_exception:
      'Det gik noget galt, da du afmeldte abonnementet – prøv igen',
    unsubscribe_expiration_invalid_signature:
      'Hmm. Linket til at afmelde fungerede ikke — prøv igen',
    cancel_subscription_exception:
      'Noget gik galt, og vi kunne ikke opsige dit abonnement. Prøv igen senere.',
    payment_cancelled:
      'Der er desværre opstået et problem - prøv igen, eller kontakt os via vores <a href="https://wetransfer.zendesk.com" rel="external">hjælpecenter</a>',
    profile_picture_upload_validation_error:
      'Filen er for stor eller ikke i png- eller jpg-format - prøv et andet billede',
    reactivate_subscription_exception: 'Der gik noget galt - prøv igen',
    retrieve_contactlist_exception:
      'Vi kunne ikke finde din liste med kontakter',
    source_retrieve_error:
      'Der er desværre opstået et problem - prøv igen, eller kontakt os via vores <a href="https://wetransfer.zendesk.com" rel="external">hjælpecenter</a>',
    token_error: 'Noget gik galt. Prøv igen.',
    update_user_error: 'Der opstod et problem med at opdatere dine oplysninger',
    wallpaper_upload_validation_error:
      'Filen er for stor eller ikke i png- eller jpg-format - prøv et andet billede',
    wallpaper_upload_validation_error_videos:
      'Hov, det ser ud til, at din video ikke opfylder specifikationerne — prøv igen',
    declined_contact_bank_error:
      'Vi kunne desværre ikke behandle betalingen — kontakt din bank.',
    invalid_password: 'Kan ikke genkende adgangskoden',
    otp_token_invalid: 'Åh, koden er forkert eller udløbet',
    projects_load_exception: 'Vi kan pt. ikke hente dine projekter',
    update_information_throttle:
      'Der opstod et problem med at opdatere dine oplysninger. Tag en %{throttle_time} pause, før du prøver igen.',
    price_amount:
      'The transfer price must be greater than %{currencySymbol}1.00 and less than %{currencySymbol}999',
  },
  navigation: {
    about_us: {
      items: {
        products: 'Produkter',
        plans_and_pricing: 'Planer og priser',
        pricing: 'Priser',
        pro_and_premium: 'WeTransfer Pro og Premium',
        about: 'WeTransfer',
        plus: 'Pro',
        apps: 'Apps',
        advertise: 'Annoncér',
        upgrade: 'Opgrader',
      },
      name_1_2019: 'Virksomhed',
      name: 'Virksomhed',
    },
    home: {
      name: 'Hjem',
    },
    help: {
      name: 'Hjælp',
    },
    got_plus: {
      name: 'Got Pro?',
    },
    signed_in: {
      name: 'Pro',
    },
    user: {
      items: {
        transfers: 'Overførsler',
        contacts: 'Kontakter',
        profile: 'Profile',
        account: 'Konto',
        received: 'Modtagne',
        sent: 'Sendte',
        teams: 'Team',
        projects: 'Projects',
      },
    },
    feedback: {
      name: 'Feedback',
    },
    sign_out: 'Log ud',
    signin: {
      name: 'Log på',
    },
    branding: 'Profilindstillinger',
    label: {
      beta: 'Beta',
      new: 'Nyt',
    },
    login: 'Log på',
    logout: 'Log af',
    portals: 'Portaler',
    signup: 'Tilmeld',
    features: {
      name: 'Egenskaber',
      all: 'Alle funktioner',
      file_sharing: 'Til fildeling',
      collaboration: 'Til samarbejde',
      security: 'Til datasikkerhed',
      branding: 'Til branding',
      fast_feedback: 'Til hurtig feedback',
    },
    referral: 'Henvis venner',
    switcher: {
      create_free_account: 'Tilføj gratis',
      just_you: 'Kun dig',
      team: 'Team',
      team_member_count: '%{amountOfMembers} medlemmer',
    },
  },
  transfer: {
    bubble: {
      errors: {
        no_internet:
          'Det ser ud til, at du ikke har forbindelse til internettet',
        begins_space:
          'Vi kan ikke sende filer, hvor navnet begynder med et mellemrum. Omdøb, og prøv igen.',
        begins_stop:
          'Vi kan ikke sende filer, hvor navnet begynder med et punktum. Omdøb, og prøv igen.',
        blocked:
          'Vi kunne ikke indlæse WeTransfer – det ser ud til, at du er blevet blokeret',
        generic: 'Desværre, der gik noget galt under overførslen',
        has_blackslash:
          'Vi kan ikke sende filer, hvor navnet indeholder en skråstreg. Omdøb, og prøv igen.',
        has_linebreak:
          'Vi kan ikke sende filer, hvor navnet indeholder et linjeskift. Omdøb, og prøv igen.',
        incorrect_recipient:
          'Det ser ud til, at en af de e-mailadresser, du har indtastet, er forkert',
        incorrect_sender:
          'Det ser ud til, at der er et problem med e-mailadressen',
        io_error: 'Der er et problem med dine filer',
        long_filename:
          'Vi kan ikke sende filer, hvor navnet indeholder mere end 250 tegn. Omdøb, og prøv igen.',
        long_message: 'Beskeden er lidt for lang – prøv at gøre den kortere',
        missing_default_recipient:
          'Kun en registreret WeTransfer Pro-e-mailadresse kan modtage mere end %{free_transfer_limit}. Opdater siden for at starte igen.',
        no_clipboard: 'Det ser ud til, at du ikke har kopieret linket',
        no_files: 'Det ser ud til, at du endnu ikke har tilføjet nogen filer!',
        no_folders:
          'Du bliver nødt til at zippe/komprimere mappen, før vi kan sende den',
        no_recipient:
          'Vi skal bruge den e-mailadresse, du ønsker at sende filerne til',
        no_sender: 'Nu mangler vi blot din e-mailadresse, og så er vi klar',
        too_big:
          'Uha – vi kan ikke overføre mere end %{upload_limit} ad gangen',
        too_many_recipient:
          'Hov – vores grænse er %{count} modtagere. Skal du sende til flere? Så kan du med fordel gøre brug af et link til overførslen.',
        unavailable:
          'Desværre - overførslen er slettet og er ikke længere tilgængelig',
        wrong_password:
          'Hmm. Adgangskoden er ikke rigtig. Prøv igen, eller tjek med den person, der sendte dig overførslen?',
        default_title: 'Hov!',
        duplicate_filename:
          'Vi kan ikke sende flere filer med samme navn. Omdøb, og prøv igen.',
        firstaccept: 'Du skal godkende, før du kan sende',
        not_downloadable:
          'Hmm, der gik noget galt, mens vi prøvede at hente dine filer. Genindlæs venligst siden, og prøv igen.',
        recaptcha: {
          text: 'Der gik noget galt. Prøv igen!',
          title: 'Ups...',
        },
        too_big_text:
          'Du kan højst overføre %{upload_limit} ad gangen. Send op til %{plus_limit} med Pro. ',
        too_big_title: 'Hej "big sender"',
        too_many_files: 'Du kan ikke sende mere end %{count} filer ad gangen',
        too_many_recipient_text:
          'Du kan overføre filer til op til 50 personer med Pro.',
        too_many_recipient_title: 'Det er for mange modtagere',
        unavailable_forward:
          'Det ser desværre ud til, at overførslen er slettet, så vi kan ikke videresende den',
        verify: {
          button: 'Ny kode, tak!',
          text: 'Prøv igen, eller anmod om en ny kode. ',
          title: 'Ups!',
        },
      },
      buttons: {
        check_out: 'Se lige her!',
        help: 'Helpcenter',
        plus: 'Få Pro',
        get_link: 'Hent link',
      },
      tips: {
        change_type:
          'Send dit overførselslink via email, eller generér et link, du kan dele, som du har lyst til',
        contacts:
          'Alle, du sender filer til, tilføjes automatisk til dine kontakter',
        expiry:
          'Med WeTransfer Pro bestemmer du, hvornår dine filer skal udløbe. (Du kan også ændre datoen for udløb efter at overførslen er sendt!)',
        free_limit:
          'Godt nyt! Du kan sende op til %{size} ad gangen. Og endnu bedre - du kan bruge tjenesten så mange gange, du ønsker!',
        message: 'Hvis du vil, kan du her føje en besked til din overførsel',
        password:
          'Hvis du ønsker ekstra sikkerhed, kan du beskytte overførslen med en adgangskode. Bemærk, at vi ikke tilføjer adgangskoden i emailen, så du bliver nødt til selv at give den til de rette personer!',
        recipient_limit:
          'Tilføj op til %{email_limit} e-mailadresser, eller opret et link i menuen ved siden af overførselsknappen',
        transfer_history: 'Din overførsel er gemt i din overførselsoversigt',
        your_email:
          'Sæt din egen e-mailadresse ind her, så vi kan give dig besked, når filerne er downloadet',
        link_transfer:
          'Vidste du, at du kan snuppe dit overførselslink lige her?',
        previews_receiver:
          'Billeder, der sendes af en Pro-bruger, kan blive vist inden det downloades. Klik på en fil og se, hvad den indeholder!',
        previews_sender:
          'Hvis man sender et billede, kan man få det vist inden det downloades',
        vrl_text: 'Nu kan du se dine filer uden at downloade dem.',
        vrl_title: 'Forhåndsvis filer',
        zip_text: 'Skal du sende en mappe? Vi laver zip-filen for dig',
        zip_title: 'Du behøver ikke at lave en zip-fil',
        add_display_name_tooltip:
          'Giv din overførsel en titel, så folk ved, hvad dine filer omhandler. Det gør det også nemmere at finde dem senere.',
        anonymous_sender: {
          button: 'Få et link',
          text: 'Indtast din e-mailadresse her, så vi kan give dig besked, når dine filer er blevet downloadet.\n\nDu skal bekræfte din e-mailadresse, så vi ved, at du er dig. Ønsker du ikke at bekræfte hver eneste gang?',
          text_locked_recipient:
            'Indtast din e-mailadresse her, så vi kan give dig besked, når dine filer er blevet downloadet.\n\nDu skal bekræfte din e-mailadresse, så vi ved, at du er dig.',
        },
        prefer_link: {
          button: 'Få et link',
          text: 'Ønsker du ikke at verificere din e-mail? Det er bare ok.',
        },
      },
      button: {
        previews_receiver_learnmore: 'Få mere at vide',
        previews_sender_learnmore: 'Få mere at vide',
      },
      recipient_locked_text:
        'På denne side kan ejeren af kontoen modtage filer. Log på, hvis det er dig, eller gå til <a href="https://wetransfer.com">wetransfer.com</a> for at sende til andre.',
      recipient_locked_title: 'Se her',
      title: {
        previews_receiver: 'Nu med billedvisning',
        previews_sender: 'Nu med billedvisning',
      },
    },
    download: {
      blocked: {
        link: 'Læs mere',
        text: 'Denne overførsel er blevet rapporteret og kan ikke downloades',
        title: 'Overførsel blokkeret',
      },
      title: 'Klar, når du er!',
      expires: 'Filerne udløber om %{relative_time}',
      expires_never: 'Ingen dato for udløb',
      files: '%{count} filer, %{size}',
      format: '%{files}・%{expires}',
      expand: 'mere',
      download_link: 'Link til download',
      files_nosize: {
        one: '%{count} fil',
        other: '%{count} filer',
      },
      show_all_files_mobile: 'Vis alle filer',
      zip_information:
        'Du modtager en .zip-fil, når du downloader alle filer på én gang - <a href="https://wetransfer.zendesk.com/hc/en-us/sections/201887176-Downloading-a-transfer-on-a-mobile-device" rel="external">læs mere</a>',
      files_label: 'Files',
      message: 'Besked',
      learn_more: 'få mere at vide',
      expires_in: 'Udløber om %{expiry}',
      download_all_zip:
        'Hvis du vælger at downloade alle, downloades alle filer som en .zip-fil',
      back_to_transfer: 'Tilbage til overførsel',
      cookie_text:
        'Vi bruger cookies til at sikre, at du får den bedste oplevelse. Bare rolig, vi sælger ikke dine data til tredjeparter. Administrer dine <a href="https://wetransfer.com/legal/manage-cookies" rel="external">indstillinger for data</a>.',
    },
    preview: {
      open_grid: 'Forhåndsvisning',
      click_to_open: 'Klik for at se',
      grid: 'Indhold i denne overførsel',
      link: 'Websted',
      not_previewable: 'Intet preview',
      now_open: 'Preview åben',
      open_link: 'Åbn link i ny fane',
      open_link_short: 'Åbn link',
      overview: 'oversigt',
      reload: 'Klik her for at genindlæse',
      something_went_wrong: 'Ups, der gik noget galt',
      tap_to_open: 'Tryk for at se',
      toobig_copy:
        'Preview er kun muligt for billeder på op til 50 MB – <a href="https://wetransfer.zendesk.com/" rel="external">læs mere her</a>',
      toobig_title: 'Øv! Det her billede er for stort til et preview.',
      unsupported_copy:
        'Tjek <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115003447483" rel="external">her</a> for at se hvilke filer, vi kan vise som preview',
      unsupported_title: 'Denne fil kan ikke vises (endnu)',
      visit_website: 'Gå til websted',
    },
    complete_mobile: {
      email_text:
        'Overførselsmailen er sendt – din overførsel er tilgængelig i %{expires}',
      link_text: 'Kopier dit link til download:',
      email_text_no_expiry: 'En e-mail er sendt til modtageren',
    },
    'consent-manager': {
      art: {
        'short-v': {
          subtitle:
            '<b>Vidste du, at 30 % af vores reklameplads er forbeholdt kunstnere?</b> Når du tillader vores cookies, giver du os lov til at vise dig en lille bid kunst, vigtige emner, som vi brænder for, samt prisvindende annoncer – uden at det kommer i vejen. ',
          text: 'Vil du også tillade cookies fra vores tredjepartsannoncepartnere, så vi kan vise dig personligt tilpassede annoncer? ',
          title: 'Vores cookies giver kulturen næring',
        },
        subtitle:
          '<b>Derfor går 30 % af vores reklameplads til kunstnere.</b> Når du tillader vores cookies, giver du os lov til at vise dig en lille bid kunst, vigtige emner, som vi brænder for, samt prisvindende annoncer – uden at det kommer i vejen. ',
        text: 'Vores website bruger cookies til at fungere korrekt. De hjælper os med at forstå, hvordan du bruger WeTransfer, og forbedre sitets ydeevne. Vil du også tillade cookies fra vores tredjepartsannoncepartnere, så vi kan vise dig personligt tilpassede annoncer?',
        title: 'Vi tror på, at kunst kan flytte bjerge',
        'title-small': 'Velkommen til WeTransfer',
      },
      'button-accept': 'Tillad',
      'button-accept-all': 'Tillad alle',
      'button-ccpa': 'Fravælg salg af personlige oplysninger',
      'button-cookies-privacy': 'Dine privatlivsvalg',
      'button-reject': 'Nej tak',
      'button-save': 'Gem',
      'button-save-and-exit': 'Gem og luk',
      'ccpa-banner-text':
        'Vi bruger cookies til at sikre, at du får den bedste oplevelse på vores hjemmeside. Bare rolig, vi sælger ikke dine data til tredjeparter. Vil du fravælge alligevel? <a href="%{href}">Administrer indstillinger</a>',
      'ccpa-body':
        'Eftersom du er i USA, er dine rettigheder beskyttet af California Consumer Privacy Act (CCPA), og du kan bede os om at stoppe med at sælge dine personlige oplysninger. Det betyder ikke, at vi sælger dine personlige oplysninger eller private filer til højestbydende tredjepart — det har vi aldrig gjort og vil aldrig gøre! Vi bestræber os på at holde dit digitale fodaftryk lille, sikkert og sørger for at du har fuld kontrol. Du kan læse mere om, hvilke data vi indsamler og hvorfor i <a href="%{href}">Dine privatlivsvalg</a>.',
      'ccpa-donotsell': 'Sælg ikke mine personlige oplysninger',
      'ccpa-header': 'Fravælg salg af personlige oplysninger',
      'ccpa-intro':
        'Som en ansvarlig teknologivirksomhed, der er forpligtet til et bedre internet, sælger vi ikke dine data til tredjeparter. Men du har alligevel ret til officielt at fravælge det.',
      'ccpa-variant-test-text':
        'Vi bruger cookies til at sikre en gnidningsfri oplevelse på vores hjemmeside samt til at tilpasse de reklamer, du ser.  <a href="%{href}">Håndtér cookies</a>',
      headline: 'Cookies og annoncer',
      intro:
        'Vi bruger beløbene fra vores fine annoncer til at dække vores faste udgifter. Det giver os mulighed for at tilbyde vores fildelingstjeneste gratis.',
      'manage-cookies': 'Administrer cookies',
      'partners-consent': 'Tillad',
      'partners-features': 'Egenskaber',
      'partners-headline': 'Vores partnere',
      'partners-text':
        '<p>Her finder du en alfabetisk liste over de nøje udvalgte partnere, som vi giver adgang til at analysere dine oplysninger, så vi kan spore og forbedre vores tjenester.</p>',
      'preferences-headline': 'Administrer cookies ',
      'preferences-text':
        '<p>Vi respekterer din ret til privatliv og dine valg omkring dine personoplysninger. Når du bruger vores tjeneste, er vi nødt til at behandle nogle af dine personoplysninger. Vi har valgt at tage en ansvarlig og værdibaseret tilgang til vores forretning, teknologi og i vores forhold til dig.</p>\n<p>Derfor går vi langt for at minimere dit digitale fodaftryk, beskytte det og lade det være i din kontrol.</p>\n<p>Som standard indsamler og behandler vi kun data, når det er strengt nødvendigt. Hvis du ønsker at støtte vores tjeneste, så vi fortsat kan tilbyde et gratis WeTransfer, vil vi dog bede dig om at give os tilladelse til at dele dine oplysninger med vores annoncepartnere.</p>',
      'preferences-text-allow-cookies':
        'Tillad cookies, så vi og/eller vores partnere kan:<br><br>',
      'purpose-description-first-intro':
        'I vores markedsføring af produkter på og uden for vores website og apps kan WeTransfer: ',
      'purpose-description-first-list':
        '<ul><li>Indsamle oplysninger om hvordan du interagerer med vores website(s), såsom hvor du klikker, og hvilke sider du besøger, og (hvor det er muligt) sammenholde denne viden med de personoplysninger vi har gemt om dig, såsom e-mailadressen til din konto</li><li>Bruge de oplysninger vi har indsamlet til at sende dig tilbud og kampagner via e-mail; på vores egne website(s) eller apps; og tredjepartswebsites eller -apps. Eksempelvis kan vi markedsføre et af vores andre produkter til dig, når du bruger WeTransfer Pro.</li></ul>',
      'purpose-description-second-intro':
        'I deres markedsføring af produkter på og uden for vores website og apps kan vores partnere: ',
      'purpose-description-second-list':
        '<ul><li>Indsamle oplysninger om hvordan du interagerer med vores website(s), såsom hvor du klikker, og hvilke sider du besøger, og (hvor det er muligt) sammenholde denne viden med de personoplysninger de har gemt om dig</li><li>Bruge de oplysninger de har indsamlet til at sende dig tilbud og kampagner via e-mail; på deres egne website(s) eller apps; og på websites eller apps tilhørende de tredjeparter, som de samarbejder med.</li></ul>',
      'purpose-title':
        'Markedsføre produkter på og uden for vores website og apps',
      'switch-by-partners': 'Fra partnere',
      'switch-by-we-transfer': 'Fra WeTransfer',
      text: '<p>Vores website bruger <a href="%{href}">cookies</a>. De får websitet til at fungere optimalt, giver os mulighed for at analysere din færden på sitet og hjælper os med at forbedre vores tjeneste.</p>\n<p>Vil du også tillade cookies fra vores annoncepartnere, så vi kan vise dig skræddersyede annoncer og markedsføre produkter fra WeTransfer og vores partnere på og uden for vores websites og apps?</p>',
      'text-panel':
        '<p>Vores website bruger cookies. De får websitet til at fungere optimalt, giver os mulighed for at analysere din færden på sitet og hjælper os med at forbedre vores tjeneste.</p>\n<p>Vil du også tillade cookies fra vores annoncepartnere, så vi kan vise dig skræddersyede annoncer og markedsføre produkter fra WeTransfer og vores partnere på og uden for vores websites og apps?</p>',
      'tos-experiment': {
        'cookie-intro':
          'Den nemmeste måde at sende store filer på, mens du oplever fantastisk kunst og prisvindende annoncer.',
        'cookie-text':
          'Vores website bruger cookies til at fungere korrekt og til at hjælpe os med at analysere, hvordan du bruger sitet, og forbedre dets ydeevne.\nVed at godkende vores cookies, giver du os tilladelse til at vise dig personligt tilpassede annoncer. Fik vi nævnt ordet cookies nok gange? (Cookie.)',
      },
      trees: {
        'short-v': {
          subtitle:
            'Vores mission er at gøre verden smukkere gennem prisvindende annoncer, der ikke er i vejen og hjælper os med at bidrage til genopretningen af havets skove.',
          title: 'Vores cookies beskytter kloden',
        },
        subtitle:
          'Når du tillader cookies, hjælper du os med at sprede vores løfte til planeten. Alene i år har WeTransfer forpligtet sig til at plante mere end 175.000 træer, og vi er kun lige begyndt. Du bidrager positivt alene ved at opleve vores prisvindende annoncer. ',
        text: 'Vores website bruger cookies til at yde bedre, tilbyde dig en bedre tjeneste og til bedre at forstå dine behov. Når du tillader tredjepartscookies, kan vi og vores partnere tilbyde dig flere relevante annoncer på og uden for vores website(s) og apps.',
        title: 'Del dine idéer. <b>Vær med til at forandre verden.</b>',
      },
    },
    pro_pass_upsell_one: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_collect',
      text: 'Aktivér Collect Pro',
      title: 'Gem og del inspiration, mens du er på farten',
    },
    pro_pass_upsell_three: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_three',
      text: 'Fortæl mig mere',
      title: 'Paste® Pro og Collect Pro indgår nu i dit abonnement',
    },
    pro_pass_upsell_two: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_paste',
      text: 'Aktivér Paste® Pro',
      title: 'Lav dine store idéer om til smukke præsentationer',
    },
    terms_conditions: {
      experiment: {
        text: 'Godkend vores <a href="/legal/terms" data-route-type="plus">brugervilkår</a> for at fortsætte.',
        title: "Du er der <span class='tc-title-exp'>næsten</span>",
        ustitle:
          "Velkommen til den enkleste måde at <span class='tc-title-exp'>sende store filer på.</span>",
      },
      title: 'Før du starter...',
      text: 'For at forsætte skal du godkende vores <a href="/legal/terms" data-route-type="plus">servicevilkår</a> og <a href="/legal/privacy" data-route-type="plus">cookie-politik</a>. Vi anvender cookies til analytiske og funktionelle formål og tredjepartscookies til annonceringsformål.',
      language: 'Dit sprog er indstillet til',
      button: 'Jeg accepterer',
    },
    upsell_pricing: {
      text: 'Sammenlign abonnementer',
      title: 'Vil du sende større overførsler?',
      receiving: {
        title: 'Vil du have mest muligt ud af WeTransfer?',
      },
    },
    welcome: {
      card1:
        'Send og modtag %{transfer_limit}-overførsler i en <strong>fælles oversigt</strong>',
      card2:
        'Send dit arbejde fra dit teams <strong>egen WeTransfer-side</strong>',
      card3:
        'Samarbejd om præsentationer i <strong>Paste®</strong> og boards i <strong>Collect</strong>',
      cta: 'Sæt i gang',
      headline: 'Velkommen i teamet, <strong>%{first_name}!</strong>',
      'opt-in':
        'Send mig historier om kreativitet og de seneste WeTransfer-nyheder',
    },
    form: {
      num_files: {
        one: '%{count} er tilføjet · %{remaining} tilbage',
        other: '%{count} er tilføjet · %{remaining} tilbage',
      },
      add_files: 'Upload filer',
      more_files: 'Tilføj flere filer',
      available_space: 'Tilføj op til %{size}',
      message: 'Besked',
      from: 'Din e-mail',
      to: 'Send e-mail til',
      other_recipients: {
        one: '+%{count} anden',
        other: '+%{count} andre',
      },
      reset_forward: 'Annullér videresendelse',
      drop_files: 'eller træk og slip',
      files_count: {
        one: '%{count} fil tilføjet · %{fileSize} i alt',
        other: '%{count} filer tilføjet · %{fileSize} i alt',
      },
      select_folder: 'Eller vælg en folder',
    },
    progress: {
      title: 'Overfører...',
      title_cancel: 'Vil du annullere overførslen?',
      uploaded: '%{sent} af %{total} oploadet',
      remaining: {
        minutes: {
          zero: 'Under 1 minut tilbage',
          one: 'Ca. 1 minut tilbage',
          other: 'Ca. %{count} minutter tilbage',
        },
        hours: {
          one: 'Der er ca. 1 time tilbage',
          other: 'Der er ca. %{count} timer tilbage',
        },
      },
      document_title: '%{percentage}% - Overfører...',
      meta: {
        email: {
          one_file_one_recipient:
            'Sender %{filesCount} fil til %{recipientsCount} person',
          one_file_other_recipients:
            'Sender %{filesCount} fil til %{recipientsCount} personer',
          other_files_one_recipient:
            'Sender %{filesCount} filer til %{recipientsCount} person',
          other_files_other_recipients:
            'Sender %{filesCount} filer til %{recipientsCount} personer',
        },
        link: {
          one: 'Sender %{count} fil',
          other: 'Sender %{count} filer',
        },
      },
    },
    complete_link: {
      title: 'Færdig!',
      text: 'Kopiér dit link til download eller<a href="/transfer/progress">se, hvad det indeholder</a>',
      text_copied: 'Linket er kopieret til udklipsholderen',
      text_manual_copy:
        'Linket er klar \nTryk på %{shortcut} for at kopiere det til udklipsholderen',
      document_title: 'Sådan!',
      text_pre_qr: 'Copy your download link or',
      text_get_qr: 'Get QR code',
      text_see_qr: 'See QR code',
    },
    storage_full_block: {
      information_detail_link: 'a lot of files',
      information_detail_text: 'You’re storing ',
      instruction_detail_link: 'request a storage boost',
      instruction_detail_text: 'Please <b>clean up some old files</b> or ',
      title: 'Hey, big sender',
      cta: 'Clean up',
    },
    complete_forward: {
      title: 'Overførslen er videresendt',
    },
    complete_email: {
      title: 'Færdig!',
      text: 'Overførselsmailen er sendt – din overførsel er tilgængelig i %{expires}.<a href="/transfer/progress">Se, hvad den indeholder</a>',
      text_no_expiry:
        'Overførselsmailen er sendt. <a href="/transfer/progress">Se, hvad den indeholder</a>',
      document_title: 'Sendt!',
      text_no_details:
        'Overførselsmailen er sendt – din overførsel er tilgængelig i %{expires}.',
      team_discovery_title: 'Overførsel er sendt!',
      team_discovery_text:
        'Din overførsel vil være tilgængelig til download i %{expires}',
    },
    failed: {
      title: 'Hmm, der gik noget galt',
      text: 'Det ser ud til, at din overførsel gik galt – prøv en gang til',
    },
    pending: {
      title: 'Vi er næsten klar...',
      subtitle: 'Forbereder...',
    },
    downloading: {
      title: 'Henter dine filer...',
      text: 'Vi er ved at forberede dit download',
    },
    downloaded: {
      title: 'Dit download er påbegyndt',
      text: "Når overførslen er færdig, vil filerne være at finde på din computer (ofte i mappen 'overførsler')",
      download_links:
        'Du skal være klar over, at linkene i dette Board ikke dukker op – <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115005062963" rel="external">læs mere her</a>.',
    },
    expired: {
      title: 'Overførslen er udløbet',
      text: 'Beklager, overførslen er udløbet og er ikke længere tilgængelig',
    },
    password: {
      title: 'Indtast adgangskode',
      text: 'Du skal bruge en adgangskode for at downloade denne overførsel',
    },
    options: {
      transfer_type: 'Send som',
      password: 'Adgangskode',
      password_placeholder: 'Indstil adgangskode',
      expiry: 'Udløber efter',
      expire_in: {
        '1w': '1 uge',
        '2w': '2 uger',
        '1m': '4 uger',
        never: 'Aldrig',
        '14d': '2 uger',
        '28d': '4 uger',
        '365d': '1 år',
        '7d': '1 uge',
        '90d': '3 måneder',
      },
      email: 'e-mail',
      link: 'link',
      email_transfer: 'Send en overførsel på e-mail',
      transfer_link: 'Hent overførselslink',
    },
    buttons: {
      transfer: 'Overfør',
      forward: 'Videresend',
      new_transfer: 'Send en fil?',
      cancel: 'Annullér',
      cancel_no: 'Nej',
      cancel_yes: 'Ja',
      copy_link: 'Kopiér link',
      ok: 'OK',
      done: 'Send mere?',
      team_discovery_done: 'Send en ny overførsel',
      retry: 'Prøv igen',
      continue: 'Fortsæt',
      download: 'Download',
      download_all: 'Download alt',
      back_to_home: 'Tilbage til start',
      cleanup: 'Gennemse overførsler ',
      download_all_files: 'Download alle filer',
      help: 'Helpcenter',
      payment: 'Forny nu',
      complete_order: 'Gå til kassen',
      download_all_experiment: 'Download alt som zip-fil',
      download_experiment: 'Download fil',
      download_file: 'Download fil',
      download_zip: 'Download alt som zip-fil',
      get_link: 'Hent link',
      go_to_transfer: 'Gå til overførsel',
      openinapp: 'Gem med WeTransfer-appen',
      openinapp_experiment: 'Gem med WeTransfer-appen',
      openincollectapp: 'Gem med Collect-appen',
      get_a_link: 'Få et link',
    },
    account_expired: {
      text: 'Forny nu, så du fortsat kan nyde alle fordelene ved din Pro-konto, eller <a href="#signout">log af for at bruge vores gratis tjeneste</a>',
      title: 'Din Pro-konto er udløbet',
    },
    invalid: {
      text: 'Vi kunne ikke finde dine filer',
      title: 'Ups...',
      link: 'Få mere at vide',
    },
    outdated_browser: {
      text: 'WeTransfer understøtter en række webbrowsere, men det ser ud til, at din er for gammel — opdatér venligst din browser',
      title: 'Din webbrowser er forældet',
    },
    spam: {
      text: 'Denne overførsel blev anmeldt som spam og blev slettet',
      title: 'Hmm...',
    },
    upsell: {
      text: 'Øg grænsen',
      limit: 'Op til %{limit} gratis',
      remaining: '%{remaining} TILBAGE',
    },
    upsell_five: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Få WeTransfer Pro',
      title: 'Få ro i sindet ved at adgangskodesikre dine overførsler',
    },
    upsell_four: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Få WeTransfer Pro',
      title: 'En smartere og lettere måde at håndtere dine overførsler på',
    },
    upsell_one: {
      bubble: {
        button: 'Få Pro',
        text: 'Beskyt dine filer med en adgangskode, og vælg en dato for udløb.',
        title: 'Opgrader overførsel?',
        text_experiment:
          'Med Pro kan du oprette adgangskoder og udløbsdatoer for dine overførsler.',
      },
      href: 'https://www.facebook.com/wetransfer',
      text: 'WeTransfer på Facebook',
      title: 'Bliv en del af WeTransfer-gruppen på Facebook',
    },
    upsell_three: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Få WeTransfer Pro',
      title: 'Gør din WeTransfer-profil personlig',
    },
    upsell_two: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Få WeTransfer Pro',
      title: 'Bliv større, bedre, stærkere, hurtigere',
    },
    account_inactive: {
      text: 'Du skal fuldføre registreringen for at komme i gang med Pro',
      title: 'Din konto er endnu ikke aktiveret',
      tiers: {
        text: 'Afslut din betaling for at komme i gang med %{plan}.',
        title: 'Dit abonnement er ikke aktivt endnu',
      },
    },
    add_items: {
      files: 'Filer',
      folders: 'Mapper',
    },
    complete: {
      open_panel:
        '<a href="/transfer/progress">Vil du se, hvad der er indeni</a>?',
    },
    details: {
      button: {
        dismiss: 'Afvis',
      },
    },
    download_preview: 'Download fil',
    error: {
      expired: {
        link: 'Kontakt vores support-team.',
        text: 'Øv, det lader til, at din overførsel allerede er udløbet.\nLyder det forkert?',
        title: 'Overførslen er udløbet',
      },
    },
    item: {
      details: {
        folder: 'Mappe',
      },
    },
    items: {
      zero: 'tom',
      one: '%{count} fil',
      other: '%{count} filer',
    },
    mobile: {
      button: {
        back: 'Tilbage',
        cancel: 'Begynd forfra',
        next: 'Næste',
      },
      email: {
        title: 'Tilføj en e-mailadresse',
      },
      message: {
        placeholder: 'Tilføj en besked til din overførsel',
        title: 'Besked',
      },
      options: {
        email: 'Send en e-mail',
        'email-description':
          'Send din overførsel i en e-mail og få besked, når den er downloadet.',
        link: 'Få et link',
        'link-description':
          'Opret et link til dine filer og del dem, som du ønsker.',
      },
    },
    recaptcha: {
      button: 'Er et menneske',
      text: 'Vi skal bare sikre os, at du ikke er en robot (tag det ikke personligt)',
      title: 'Du er næsten færdig!',
    },
    upsell_survey: {
      href: 'https://www.surveymonkey.com/r/2HTSNSZ',
      text: 'Hjælp os',
      title: 'Kan vi spørge dig lidt om den måde, du arbejder på?',
    },
    'verification-code': 'Bekræftelseskode',
    verify: {
      button: 'Begynd overførsel',
      text: 'Find bekræftelseskoden i din indbakke, og indtast den nedenfor.',
      title: 'Du har fået mail',
      'verification-code': 'Bekræftelseskode',
    },
    'account-verification-failed': {
      body: 'Vi kan ikke bekræfte din e-mailadresse. Send et nyt link, og prøv igen.',
      cta: 'Send et nyt link?',
      title: 'Der opstod en fejl',
    },
    'cookie-banner': {
      'button-accept': 'Fint',
      'button-decline': 'Niks',
      text: 'Vi bruger <a href="%{href}">cookies</a>. De får hjemmesiden til at fungere, giver os mulighed for at analysere, hvordan brugere interagerer på siden og hjælper os med at forbedre den. Vil du også tillade tredjepartcookies, så du kan modtage personligt tilpassede reklamer?',
    },
    'cookie-manager': {
      analytical: {
        description:
          'Vi bruger analytiske cookies til at hjælpe os med at forstå, hvordan du bruger WeTransfer. De giver os mulighed for at A/B-teste nye funktioner, sikre, at alt fungerer som det skal og stoppe bots og ondsindet adfærd såsom spam. Disse cookies kan omfatte tredjepartscookies, der behandler personlige oplysninger. ',
        title: 'Analytiske cookies',
      },
      clear: {
        'clear-all-cookies': 'Ryd alle cookies',
        description:
          'Du kan fjerne alle dine data fra vores cookies. Hvis du ønsker permanent anonymitet, bedes du <a href="mailto:support@wetransfer.com">kontakte vores supportteam.</a>',
        title: 'Ryd cookies',
        warning:
          'Du vil blive logget ud af WeTransfer, når cookies er fjernet. Dette påvirker ikke overførsler på din konto.',
      },
      functional: {
        description:
          'Vi bruger funktionelle cookies til at sikre en problemfri oplevelse for dig på WeTransfer. De er nødvendige for at kunne bruge vores tjeneste.',
        title: 'Funktionelle cookies',
      },
      'not-yet-set':
        'Det ser ud til, at du ikke har givet os din cookiepræference endnu. Luk dette panel og indstil din præference. Du kan altid ændre det her bagefter.',
      'save-and-reload': 'Gem indstillinger',
      tracking: {
        description:
          'Vi bruger annonceringscookies på vores tjeneste til at hjælpe os med at måle succesen af vores kommercielle, redaktionelle og salgsfremmende indsats. Annonceringscookies placeres ikke på sider, der indeholder oplysninger om vores brand og produkter. Annonceringscookies giver os mulighed for f.eks. at registrere, at du har klikket på en bestemt annonce. Hvis cookies, der er placeret af tredjeparter, også placeres på andre domæner og websteder, kan annoncører muligvis følge din adfærd på tværs af internettet, men WeTransfer kan ikke få adgang til eller bruge nogen af disse personlige oplysninger, der kan indsamles. Derfor henviser vi dig til de relevante tredjeparters privatlivspolitikker.',
        title: 'Annonceringscookies',
      },
    },
    'email-verification-resend': {
      account: {
        error: 'Hov, noget gik galt',
        'error-email-exists':
          'Hov, det ser ud til, at denne e-mailadresse allerede er i brug',
        'throttle-error':
          'Wow, vi har sendt dig alt for mange e-mails nu. Vent %{throttle_time}, inden du anmoder om en ny kode.',
      },
      back: 'Tilbage til bekræftelse med kode',
      body: 'Er det korrekt forstået? Dette er den e-mailadresse, som du bruger på WeTransfer.',
      email: 'E-mail',
      error: 'Hov, noget gik galt',
      'error-email-exists':
        'Hov, det ser ud til at denne e-mail allerede er i brug',
      submit: 'Gensend',
      'throttle-error':
        'Beklager, du har forsøgt for mange gange. Start din overførsel igen.',
      'throttle-error-action': 'Prøv igen',
      'throttle-error-link':
        'Wow, vi har sendt dig alt for mange e-mails nu. Vent %{throttle_time}, inden du anmoder om en ny email.',
      title: 'Tjek din e-mail',
    },
    'email-verification-success': {
      body: 'Nu kan folk være sikre på, at dine overførsler virkelig kommer fra dig.',
      free_signup: 'Opret en gratis konto',
      onboarding_body:
        'Highfive, du er oprettet! Er du klar til at vælge din egen URL og baggrund?',
      onboarding_title: 'Velkommen til<br/>WeTransfer Pro!',
      send_files: 'Send filer',
      start_onboarding: 'Sæt i gang',
      title: 'Din konto er bekræftet!',
      upsell: 'Vil du slippe for at bekræfte din e-mailadresse hver gang?',
      verified_sender_tooltip:
        'Din e-mail er blevet bekræftet, så andre kan se, at overførslerne er blevet sendt af dig. Hvis du vil ændre denne e-mailadresse, skal du opdatere dine <a href="%{href}">personlige oplysninger</a>.',
      verified_sender_tooltip_icon:
        'Du har bekræftet din e-mailadresse. Det betyder, at andre kan se, at overførslerne er blevet sendt af dig.',
    },
    'email-verification': {
      account: {
        'error-expiry-time':
          'Åh, koden er forkert eller udløbet. Koder er kun aktive i %{expiry_time} efter afsendelse.',
        'error-expiry-time-action': 'Modtag en ny kode',
        'throttle-error':
          'Du har indtastet en forkert eller udløbet kode for mange gange. Vent %{throttle_time}, inden du anmoder om en ny kode.',
      },
      back: 'Gå tilbage',
      body: 'Vi har sendt en bekræftelseskode til <strong title="%{account_email}">%{account_email}</strong>for at tjekke, at det virkelig er dig. (Husk at tjekke din spam-mappe).',
      body_link:
        'En hurtig kontrol for at sikre, at du er dig.<br/><br/>Vi har sendt et bekræftelseslink til <strong title="%{account_email}">%{account_email}</strong> (se under spam, hvis du ikke finder e-mailen).',
      error: 'Åh, koden er forkert eller udløbet',
      'error-expiry-time':
        'Åh, koden er forkert eller udløbet. Koder er kun aktive i %{expiry_time} efter afsendelse.',
      'error-expiry-time-action': 'Modtag en ny kode',
      resend: 'Har du ikke modtaget en e-mail?',
      submit: 'Bekræft',
      'throttle-error':
        'Beklager, du har forsøgt for mange gange. Start din overførsel igen.',
      'throttle-error-action': 'Prøv igen',
      title: 'Bekræft din e-mail',
      'verification-code': 'Indtast bekræftelseskode',
    },
    'force-account-verification': {
      body: 'Vi sender dig et link for at bekræfte den e-mailadresse, du bruger på WeTransfer.',
      cta: 'Send e-mail',
    },
    'marketing-email-prompt': {
      body: 'En ting til – vil du modtage nyheder og produktopdateringer fra WeTransfer?',
      skip: 'Nej tak',
      subscribe: 'Ja, giv lyd',
      title: 'Du er godkendt!',
    },
    'terms_conditions-no-cookies': {
      text: 'Du skal godkende vores <a href="/legal/terms?from_home" data-route-type="plus">servicevilkår</a> for at fortsætte.',
    },
    mobile_web: {
      ios_banner_prompt: 'Hent dine filer i WeTransfer-appen',
      ios_banner_prompt_send: 'Send filer hurtigt og nemt',
      tnc_subtitle: 'Den mest enkle metode til at sende store filer',
    },
  },
  account: {
    legend: {
      plan: 'Plan',
      save: 'spar %{amount} %',
      subscription: 'Abonnement',
      summary: 'Bestillingsoversigt',
      wetransfer_premium: 'WeTransfer Premium',
    },
    'verify-info': 'Derfor har vi brug for, at du bekræfter din e-mail',
    workspace: {
      default_workspace: '%{name}s arbejdsområde',
      your_workspace: 'Dit arbejdsområde',
    },
    consent_manager: {
      data_opt_in: {
        title: 'Dine privatlivsvalg',
        subtitle: 'Administrer dine data',
        p1: 'Vi ønsker altid at give dig den bedste oplevelse, også hvad angår vores reklame.',
        p2: 'Vi vil gerne bruge de data, som du vælger at dele, f.eks. din e-mailadresse, til at forstå, hvilken slags indhold du synes bedst om og bruge det til at vise dig (og andre som dig) WeTransfer-annoncer, der er skræddersyet til dine behov.',
        p3: 'Alt det, du opretter og deler med WeTransfer, forbliver privat for dig - vi læser eller bruger det ikke til reklameformål.',
        p4: 'Hvis du beslutter dig for at dele med os, vil disse oplysninger altid forblive sikre.',
        control_label:
          'Lad WeTransfer bruge de data, du deler, såsom din e-mailadresse og arbejdsområde, til at skræddersy de annoncer, du ser på og uden for vores websites.',
      },
      vertical_nav: {
        terms_of_service: 'Servicevilkår',
        privacy_and_cookie_statement: 'Privatlivs- og cookieerklæring',
        your_privacy_choices: 'Dine privatlivsvalg',
        notice_and_takedown_policy: 'Politik for meddelelser og fjernelse',
        responsible_disclosure_policy: 'Politik for ansvarlig offentliggørelse',
        advertising_terms_and_conditions: 'Annonceringsvilkår og -betingelser',
      },
    },
  },
  account_onboarding_navigation: {
    cta: 'Luk, og gå til send filer',
  },
  account_start_screen: {
    'collect-description':
      'Gem al inspiration på et og samme sted, uanset om du er på din telefon, laptop eller tablet.',
    'collect-title': 'Gå til Collect',
    'paste-description':
      'Skab smukke slides på få sekunder med præsentationssæt, der designer sig selv.',
    'paste-title': 'Gå til Paste®',
    title: 'Tre værktøjer. Én konto. Uendelige muligheder.',
    'transfer-cta': 'Sæt i gang',
    'transfer-description':
      'Gør et godt indtryk, hver gang nogen henter dine filer. Er du klar til at vælge din egen URL og baggrunde?',
    'transfer-title': 'Opret din egen WeTransfer-side',
  },
  account_welcome_screen: {
    'pro-title': 'Velkommen til WeTransfer Pro, <strong>%{name}!</strong>',
    accept: 'Ja tak',
    'accept-short': 'Fint',
    body_1:
      'Vil du modtage historier om kreativitet og de seneste WeTransfer-nyheder?',
    body_2: '(Du kan altid framelde dig senere.)',
    decline: 'Nej tak',
    'decline-short': 'Nej tak',
    title: 'Velkommen til WeTransfer, <strong>%{name}!</strong>',
  },
  cookie_wall_paid: {
    button: {
      accept: 'Accepter cookies',
      deny: 'Afvis cookies',
      manage: 'Administrer cookies',
    },
    description:
      'Vi bruger generelle cookies og analytiske cookies for at sikre en god oplevelse og tredjepartscookies til reklameformål.',
    heading: 'Opdag den enkleste måde at sende store filer på',
    snippet: 'Velkommen til WeTransfer',
  },
  dropzone: {
    pro: {
      title: '<span>Slip</span> den<br>så hurtigt som muligt',
    },
    title: "Drop it like it's hot",
    text: 'Upload filer eller mapper ved at trække dem til dette vindue',
  },
  form: {
    account: {
      billing_address: 'Faktureringsadresse',
      billing_cta: 'Gå til betaling',
      billing_title: 'Faktureringsoplysninger',
      legend: {
        details: 'Dine faktureringsoplysninger',
        coupon_code: 'Tilføj en rabatkode',
        free_plus: 'Hent din gratis Pro-konto',
      },
      label: {
        year_label: 'Om året',
        year_sublabel: 'Mest for pengene: spar %{discount_rate}%!',
        month_label: 'Pr. måned',
        month_sublabel: 'Tilbagevendende fakturering',
        email: 'E-mailadresse',
        not_required: '(valgfrit)',
        current_password: 'Nuværende adgangskode',
        new_password: 'Ny adgangskode',
        repeat_new_password: 'Bekræft ny adgangskode',
        password: 'Adgangskode',
        password_confirm: 'Bekræft adgangskode',
        full_name: 'Fulde navn',
        company: 'Virksomhed',
        street_and_number: 'Adresse',
        city: 'By',
        zipcode: 'Postnummer',
        country_code: 'Land',
        vat_number: 'Momsnummer',
        coupon_code: 'Rabatkode',
        family_name: 'Efternavn',
        given_name: 'Fornavn',
        state_code: 'Stat',
      },
      description: {
        password: 'Vælg en adgangskode, der indeholder mindst 6 tegn',
        vat_number:
          'Virksomheder, der er placeret i Holland, opkræves 21% moms. Hvis din virksomhed er placeret andre steder i EU, skal du, for at fjerne moms fra fakturaen, angive dine virksomhedsoplysninger og dit europæiske momsnummer \n \nHvis virksomheden er placeret uden for EU-området, skal vi stadig bruge dine fakturaoplysninger, men vi opkræver ikke moms.',
      },
      error: {
        email: {
          blank: 'Indtast din e-mailadresse',
          invalid: 'Indtast en gyldig e-mailadresse',
          taken: 'Denne e-mailadresse er allerede i brug',
          taken_login:
            'Det ser ud til, at du allerede har en konto. <a class="form-notification__message-link" href="%{login_url}">Vil du logge på?</a>',
        },
        current_password: {
          invalid: 'Kan ikke genkende adgangskoden',
          blank: 'Indtast din nuværende adgangskode',
        },
        password: {
          blank: 'Indtast din nye adgangskode',
          too_short: 'Adgangskoden skal indeholde mindst 6 tegn',
        },
        password_confirm: {
          blank: 'Bekræft din nye adgangskode',
          confirm: 'Adgangskoderne er ikke ens',
        },
        full_name: {
          blank: 'Indtast fulde navn',
          too_short: 'Hov, dit navn skal være på mindst 3 bogstaver',
        },
        street_and_number: {
          blank: 'Indtast adresse',
        },
        city: {
          blank: 'Indtast by',
        },
        zipcode: {
          blank: 'Indtast postnummer',
        },
        country_code: {
          inclusion: 'Kontroller din stavning, eller prøv et andet land',
          blank: 'Indtast land',
        },
        vat_number: {
          vat_number: 'Indtast et gyldigt momsnummer',
        },
        terms_of_service: {
          accepted:
            'Du skal godkende vores vilkår for brug, før du kan fortsætte',
        },
        no_results: 'Kontroller din stavning, eller prøv et andet land',
        convert: {
          expired:
            'Beklager, overførslen er udløbet og kan ikke gemmes. Vidste du, at du kan beholde filerne så længe du ønsker med WeTransfer Pro? Læs mere her.',
        },
        coupon_code: {
          coupon_code: 'Indtast en gyldig rabatkode',
        },
        no_state_results: 'Er dette en stat?',
      },
      complete_order: 'Fuldfør ordren',
      terms_conditions:
        'Jeg accepterer <a href="/legal/terms" %{options}>brugervilkårene</a>og har læst <a href="/legal/privacy" %{options}>erklæringen om beskyttelse af personlige oplysninger og cookies</a>',
      signup_for_plus: 'Tilmeld dig WeTransfer Pro',
      account_cta: 'Begynd',
      signup_for_account: 'Opret en WeTransfer-konto',
      'email-verification-not-verified-link':
        'Bekræft din e-mailadresse. Se den e-mail, du har fået fra os, eller <button type="button" class="button button--link">anmod om en ny e-mail</button>.',
      'email-verification-resend': {
        error: 'Hov, noget gik galt',
        info: 'Ny kode er sendt! Tjek din indbakke',
        info_link: 'Ny e-mail er sendt! Tjek din indbakke',
        'throttle-error':
          'Wow, vi har sendt dig alt for mange e-mails nu. Vent %{throttle_time}, inden du anmoder om en ny kode.',
      },
      'force-account-verification': {
        message: 'Bekræft din e-mailadresse, så vi ved, at du er dig.',
      },
      marketing_opt_in:
        'Jeg ønsker at modtage nyheder og produktopdateringer fra WeTransfer',
      sso: {
        header: 'Personlige oplysninger',
        password_reset: {
          button: 'Send e-mail',
          instructions:
            'Trænger du til lidt forandring (på kodeordsfronten)? Det klarer vi. Bare klik på knappen nedenfor, så sender vi en e-mail til <span>%{email}</span> med et link til at ændre dit kodeord.',
          success: 'E-mail sendt! Kig i din indbakke.',
          title: 'Skift din adgangskode',
        },
        wrong_user: 'Er det ikke dig? Log ud',
      },
    },
    payment_cancel: {
      submit: 'Bekræft',
      client_request:
        'Det var en kunde, der bad mig bruge WeTransfer, så jeg har ikke brug for det mere',
      different_tool: 'Jeg har fundet et andet redskab',
      extra_features:
        'Jeg har brug for ekstra funktioner, som ikke tilbydes her',
      not_enough_storage: 'Jeg har brug for mere lagringsplads',
      not_often_large_files: 'Jeg sender ikke store filer ofte nok',
      other: 'Andre årsager',
      other_more: 'Vil du fortælle mere?',
      skip: 'Spring over og opsig abonnement',
      temp_project:
        'Jeg havde kun brug for at sende store filer i forbindelse med et tidsbestemt projekt',
      too_expensive: 'Jeg synes, at det er for dyrt',
    },
    payment_cancel_reason: {
      skip: 'Jeg vil ikke give feedback',
    },
    profile: {
      label: {
        profile_title: 'Profilnavn',
        wallpaper_link: 'Link til din personlige eller firmaadresse',
      },
      error: {
        subdomain_name: {
          too_short:
            'Vi er med på, at "less is more", men din WeTransfer-URL skal være på mindst to tegn',
          domain_name:
            'Desværre, der er allerede en anden, der bruger dette navn',
          invalid:
            'Det er lidt for underligt—din WeTransfer-URL må kun indeholde bogstaver og tal (eller en tankestreg, hvis den står mellem noget)',
          taken: 'Desværre, der er allerede en anden, der bruger dette navn',
        },
        subdomain: {
          too_short: 'Indtast mindst 2 tegn',
          too_long: 'Beklager, du kan højst vælge 63 tegn',
          invalid:
            'Det er lidt for underligt—din WeTransfer-URL må kun indeholde bogstaver og tal (eller en tankestreg, hvis den står mellem noget)',
          domain_name: 'Denne URL er allerede taget',
        },
        default_recipient_email: {
          invalid: 'Indtast en gyldig e-mailadresse',
        },
        wallpaper_link: {
          invalid: 'Indtast en gyldig webadresse',
        },
      },
      success: {
        subdomain: {
          updated: 'Din URL er opdateret',
          available: 'Godt nyt, denne URL er ledig',
        },
      },
      change_background: 'Upload baggrund',
      delete_avatar: 'Slet profilbillede',
      delete_background: 'Slet baggrund',
      description: {
        title: 'Et tip, hold dig inden for 150 tegn, så alt vises på siden',
        wallpaper_link: 'Dit tapet linker til denne webadresse',
        recipient_email_locked:
          'Filer, der sendes via din profil, går kun til denne e-mail-adresse',
      },
      upload_avatar: 'Upload profilbillede',
      use_email_background_checkbox_label:
        'Brug dette tapet til alle overførsler, der sendes via min profil',
      account_email_checkbox: 'Vis e-mailadresse på profil',
      default_recipient_email_info:
        'Du kan ændre denne e-mailadresse i dine <a href="/account">personoplysninger</a>',
      change_subdomain: {
        message:
          'Vil du skifte URL til <a href="%{url}">%{subdomain}.wetransfer.com</a>? Din forrige URL vil blive tilgængelig med det samme.',
        confirm: 'Ja, skift URL',
        cancel: 'Gå tilbage',
      },
    },
    fill_in_password: 'Indtast din adgangskode for at gemme ændringerne',
    select_all: 'Vælg alt',
    deselect_all: 'Fravælg alt',
    save_changes: 'Gem ændringer',
    save: 'Gem',
    submitting: 'Gemmer…',
    cancel: 'Annullér',
    forward: 'Videresend',
    proceed: 'Fortsæt',
    delete: 'Slet',
    onboarding: {
      placeholder: {
        subdomain_name: 'vælg-et-godt-navn',
      },
      validated: {
        subdomain_name: 'Godt nyt – dette domæne er ledigt',
      },
    },
    confirm_leave:
      'Er du sikker på, at du vil forlade siden og miste ikke-gemte ændringer?',
    unsaved_changes:
      'Vil du forlade siden? Du mister alle ikke-gemte ændringer.',
    contact: {
      add_contact: 'Tilføj kontakt',
      error: {
        email: {
          duplicate: 'Denne e-mailadresse er allerede på din kontaktliste',
          invalid: 'Indtast en gyldig e-mailadresse',
        },
      },
      label: {
        company: 'Virksomhed',
        email: 'E-mailadresse',
        name: 'Navn',
      },
    },
    error: {
      current_password: {
        blank: 'Indtast din nuværende adgangskode',
        invalid: 'Kan ikke genkende adgangskoden',
      },
      email: {
        blank: 'Indtast din e-mailadresse',
        duplicate: 'Denne e-mailadresse er allerede på din kontaktliste',
        invalid: 'Indtast en gyldig e-mailadresse',
        taken: 'Denne e-mailadresse er allerede i brug',
      },
    },
    leave: 'Forlad',
    resetpassword: {
      button: {
        request_submit: 'Send',
        reset_submit: 'Gem ny adgangskode',
      },
      label: {
        confirm_new_password: 'Bekræft ny adgangskode',
        email: 'E-mailadresse',
        new_password: 'Ny adgangskode',
      },
      legend: {
        request_description:
          'Kan du ikke logge på? Vi sender dig en mail om, hvordan du nulstiller din adgangskode og kommer videre.',
        request_title: 'Har du glemt din adgangskode?',
        reset_description: 'Indtast en ny adgangskode, og kom i gang igen',
        reset_title: 'Opret en ny adgangskode',
        request_description_success_or_article:
          'Hvis du har en WeTransfer-konto, har vi sendt dig en e-mail med anmodning om at nulstille din adgangskode. Læs denne <a href="https://wetransfer.zendesk.com/hc/en-us/articles/360033809331" rel="external">artikel fra vores hjælpecenter,</a> hvis du ikke har modtaget vores e-mail inden for de næste minutter.',
      },
    },
    signin: {
      button: {
        submit: 'Log på',
      },
      label: {
        email: 'E-mailadresse',
        password: 'Adgangskode',
        remember_me: 'Husk mig',
      },
      link: {
        forgot_password: 'Har du glemt adgangskoden?',
      },
      title: 'Log på',
    },
    stay_on_page: 'Forbliv på siden',
    close_panel: 'Luk',
    go_back: 'Gå tilbage',
    labels: {
      email: 'E-mailadresse',
    },
    plan: {
      change: {
        month: 'Månedligt (%{currency}%{price})',
        title: 'Skift ordning',
        year: 'Årligt (%{currency}%{price})',
      },
      change_plan: 'Skift betalingsaftale',
      month: {
        copy: 'Løbende fakturering',
        label: 'Pr. måned',
        'label-payment': 'Månedlig betaling',
        'sub-label': 'En faktura hver måned',
        title: 'WeTransfer Pro: Månedlig betaling',
      },
      title: 'Giv dine idéer den førsteklassesbehandling, de fortjener',
      year: {
        discount: 'Spar %{rate} % (ja tak!)',
        'label-payment': 'Årlig betaling',
        'sub-label': 'Du sparer hele 17 %.',
        title: 'WeTransfer Pro: Årlig betaling',
      },
      your_order: 'Din bestilling',
    },
    save_and_continue: 'Gem og fortsæt',
    upgrade: null,
    fill_in_password_two_factor_authentication:
      'Indtast din adgangskode for at fortsætte',
  },
  mobileweb: {
    'app-upsell': {
      cta: {
        false: 'Ikke nu',
        true: 'Åbn i WeTransfer-appen',
      },
      headline: 'Hvorfor ikke tænke større?',
      headline2: 'Vil du se filerne i appen?',
      subheader: 'Send og modtag 200 GB med WeTransfer Pro',
      subheader2:
        'Se filerne, inden du downloader dem. Send og modtag overførsler, spor downloads, og modtag notifikationer.',
    },
  },
  panel: {
    warning: {
      account_expired_subtitle_tier:
        'Forny nu for at blive ved med at nyde alle fordelene ved din %{tier}-konto',
      account_expired_title_tier: 'Din %{tier}-konto er udløbet',
      account_inactive_title_tier: 'Klar til at gå til %{tier}',
      account_inactive_action: 'Ja, fortsæt',
      account_inactive_subtitle:
        'Én sidste ting, så er du færdig. Har du skiftet mening? Helt fint —',
      account_inactive_title: 'Er du klar til Pro?',
      account_subscription_action: 'Forny nu',
      account_subscription_expired: 'Din Pro-konto er udløbet',
      account_subscription_subtitle:
        'Forny den nu for at gemme dine overførsler, personlige tapeter og din webadresse. Ellers bliver de slettet inden længe!',
      account_expired_action: 'Forny nu',
      account_expired_subtitle:
        'Forny nu for at fortsætte med fordelene ved Pro-kontoen',
      account_expired_title: 'Din Pro-konto er udløbet',
      expired_transfer_subtitle:
        'Filerne er ikke længere tilgængelige. Du kan fjerne oplysningerne fra din overførselsoversigt <a>her</a>',
      expired_transfer_title: 'Overførslen er udløbet.',
      account_email_verify_logged_out:
        'Log ind for at bekræfte din e-mailadresse',
      account_inactive_sublink: 'annullér din bestilling.',
      email_unverified_mobile_cta: 'Klar til bekræftelse',
      email_unverified_text:
        "Vi har sendt en bekræftelseskode til %{email}. <a href='%{href}'>Er det ikke dig?</a>",
      email_unverified_text_link:
        "Vi har sendt en e-mail til %{email}. <a href='%{href}'>Er det ikke dig?</a>",
      email_unverified_title: 'Bekræft din e-mailadresse',
      'force-account-verification': {
        body: 'Vi sender dig et link for at sikre, at du virkelig er dig.',
      },
      'receiving-email':
        'Bemærk! Vi har udskiftet %{receiving_email} i din profil. Det betyder, at nye overførsler kun vises i din oversigt, hvis de er sendt til %{account_email}. Du kan til enhver tid ændre dette ved at opdatere dine <a href="/account">personoplysninger</a>.',
    },
    design:
      'Du har sikkert bemærket, at vi har lavet nogle ændringer hist og her! Mange af ændringerne er noget, I har ønsket. Så nyd den nye og forbedrede side (tillader vi os at sige), og send gerne feedback til os her.',
    loading_error:
      'Hmm, det ser ud til, at denne side i øjeblikket har problemer med  indlæsningen. \nVi fortsætter med at prøve, eller <a href="%{path}">prøv at opdatere</a> selv.',
    redesign_notice:
      'Du har måske bemærket, at vi <a href="/about/redesign">har lavet nogle få ændringer</a> hist og her! Meget af det er ting, I har ønsket. Nyd ændringerne og  den forbedrede side (tillader vi os at sige) <a href="/contact" rel="external">, og send os gerne feedback her<a/>.',
    return_to: 'tilbage til %{pageName}',
    close: 'Luk panel',
    cookie: {
      accept: 'Fint',
      text: 'Vi bruger cookies. Læs <a href="/legal/terms">alt det der jura</a> (indeholder ingen opskrifter).',
    },
    footer: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      jobs: 'Job',
      press: 'Presse',
      terms: 'Vilkår',
      twitter: 'Twitter',
      youtube: 'YouTube',
    },
  },
  upsell_tiers: {
    button: 'Opgradér',
    free_limit:
      'Du kan ikke sende mere end 2 GB ad gangen. Vil du gerne sende større overførsler?',
    compare_plans: {
      button: 'Sammenlign planer',
      text: 'Du kan opgradere din plan til at overføre mere end 2 GB ad gangen.',
      title: 'Har du flere filer, der skal sendes?',
    },
    mobile: {
      cta: 'Læs mere',
      header: 'Få det bedste, WeTransfer har at byde på',
      upsell_enjoy: 'Nyd godt af mere lagerplads',
      upsell_one: 'Send større overførsler',
      upsell_two: 'Tilpas din WeTransfer-side',
    },
    pro_limit:
      'Du kan ikke sende mere end 200 GB ad gangen. Vil du sende overførsler af en hvilken som helst størrelse?',
  },
  upsell_tiers_one: {
    text: 'Vil du angive adgangskoder og udløbsdatoer for dine overførsler?',
  },
  upsell_tiers_three: {
    text: 'Vil du sende overførsler til mere end %{email_limit} e-mailadresser ad gangen?',
    title: 'Det er én for meget.',
  },
  browser: {
    assets_failed: {
      text: 'Vi kunne ikke indlæse vigtige dele af vores websted.\nDe er måske blokeret af indstillingen i din firewall, proxy eller browser.\nPrøv af opdatere siden, eller kontakt os via vores <a href="https://wetransfer.zendesk.com" rel="external">helpcenter</a>.',
      title: 'Åh nej ...',
    },
    javascript_needed:
      'Du skal bruge en browser, hvor JavaScript er aktiveret, før du kan bruge WeTransfer',
  },
  languages: {
    en: 'Engelsk',
    nl: 'Holland',
  },
  shortcuts: {
    cmd_alt_l: '⌘-Alt-L',
    cmd_j: '⌘-J',
    cmd_c: '⌘-C',
    cmd_shift_j: '⌘-Shift-J',
    control_alt_l: 'Ctrl-Alt-L',
    control_j: 'Ctrl-J',
    control_c: 'Ctrl-C',
  },
  discount: {
    billing_page: {
      legal_notice:
        'Dette tilbud er tilgængeligt indtil %{end_date}. Rabatten gælder for dit første år på %{user_tier}, hvorefter abonnementet fornyes til den fulde pris på %{yearly_amount}/%{billing_period}.',
    },
    modal: {
      title: '%{discount_amount} % rabat på årlig Pro',
      subtitle: 'Rabatkode: %{coupon_code_name}',
      text_content:
        'Det er det hele. Det er aftalen. Vi giver dig en %{discount_amount} % rabat på et Pro-årsabonnement.',
      argument: {
        size_limit: 'Send og modtag 200 GB filoverførsler',
        storage_size: 'Få glæde af 1 TB lagerplads',
        unlimited_review: 'Opret ubegrænsede anmeldelser',
      },
      cta_label: 'Gør krav på rabat',
      dismiss_label: 'Ikke nu',
    },
    banner: {
      title:
        'Få %{discount_amount} % rabat på WeTransfer Pro i et år - vores hidtil bedste tilbud',
      cta_label: 'Opgradér',
    },
    pricing_page: {
      pill_label: '%{coupon_code_name} – %{discount_amount}% off',
    },
  },
  drawer: {
    first_viewing: {
      title: 'Gå sammen og overfør sammen med %{first_recipient_email}',
      subtitle:
        'Inviter dit team til at sende og modtage overførsler på dit %{user_plan}-abonnement.',
      list: {
        overview_item: 'Delt oversigt over overførsler',
        storage_limit_item:
          'Delt lagerplads på %{storage_limit} ekstra pr. person',
        branding_item: 'Delt teambranding',
        subscription_item: 'Delt abonnement og fakturering',
      },
      cta: 'Inviter team',
      dismiss_button: 'Ikke i dag',
    },
    second_viewing: {
      title: 'Gå sammen om overførsler med ${first_recipient_email}',
      subtitle:
        'Inviter dit team til at sende og modtage overførsler på dit %{user_plan}-abonnement.',
      list: {
        overview_item: 'Delt oversigt over overførsler',
        storage_limit_item:
          'Delt lagerplads på %{storage_limit} ekstra pr. person',
        branding_item: 'Delt teambranding',
        subscription_item: 'Delt abonnement og fakturering',
      },
      cta: 'Inviter team',
      dismiss_button: 'Skjul for evigt',
    },
  },
  external_links: {
    android_app: 'https://we.tl/android',
    ios_app: 'https://we.tl/iosapp',
    facebook: 'https://www.facebook.com/wetransfer',
    homerun: 'https://wetransfer.com/jobs',
    instagram: 'https://www.instagram.com/WeTransfer/',
    twitter: 'https://twitter.com/WeTransfer',
    prco: 'https://wetransfer.pr.co',
    youtube: 'https://www.youtube.com/WeTransfer',
  },
  notification: {
    update_account: 'Din konto er opdateret',
    update_password: 'Din adgangskode er opdateret',
    update_subscription: 'Din betalingsplan er opdateret',
    update_profile_success: 'Din profil er opdateret',
    link_copied: 'Linket er kopieret til din udklipsholder',
    copy_link_manual: 'Linket er markeret – kopiér det vha. %{shortcut}',
    delete_transfer_success: 'Overførslen er slettet',
    delete_transfers_success: 'Overførslerne er slettet',
    update_expiry_success: 'Datoen for udløb er opdateret.',
    onboarding_success:
      'Se din overførselsoversigt, kontakter, profilindstillinger og andre småting her',
    add_contact_success: 'Kontakten er tilføjet',
    edit_contact_success: 'Kontakten er opdateret',
    remove_contact_success: 'Kontakten er slettet',
    already_signed_in: 'Du er nu logget ind',
    cancel_subscription_success:
      'Vi er kede af, at du forlader os - dit abonnement er nu opsagt.',
    collect_app_banner_desc:
      'Se forhåndsvisninger, gem og administrer filer fra Collect-appen',
    contact_added_confirmation: 'Kontakt er tilføjet til din overførsel',
    contact_recipient_locked_text:
      'På denne side kan ejeren modtage filer. Skal du sende til en anden?',
    forward_ready: 'Overførslen er klar til videresendelse',
    mobile_app_banner_desc: 'Se, gem og administrer filer i appen',
    mobile_app_banner_title: 'Gem det i appen',
    reactivate_subscription_success:
      'Velkommen tilbage! Din konto er blevet genaktiveret. ',
    refresh_transfer_upload_lost:
      'Er du sikker på, at du vil annullere igangværende upload?',
    update_payment_success: 'Dine betalingsoplysninger er nu opdateret. Sådan.',
    update_user: 'Dine oplysninger er blevet opdateret',
    current_team_notification: 'Du bruger nu %{plan} som %{currentTeam}',
    display_name_updated: 'Titel opdateret!',
    download_started:
      "Din download er startet. Når overførslen er færdig, kan filerne findes på din computer (ofte i mappen 'overførsler')",
    logged_out:
      'Det ser ud til, at du er blevet logget af fra en anden browser. Log på igen.',
    project_delete:
      'Vil du slette <strong>%{projectName}</strong> og eventuelle filer, du har føjet til den?',
    project_delete_success: '<strong>%{projectName}</strong> er blevet slettet',
    password_changed: 'Adgangskode ændret',
    password_removed: 'Adgangskode fjernet',
  },
  alert: {
    confirm_cancel_upload_image:
      'Er du sikker på, at du vil annullere igangværende upload? ',
    cancel_recipient_locked: 'Annuller',
    cancel_refresh_transfer_upload_lost: 'Nej',
    confirm_refresh_transfer_upload_lost: 'Ja',
    go_to_transfer: 'Gå til overførsel',
    redirect_recipient_locked: 'Ja',
    stay: 'Bliv',
    cancel_project_delete: 'Annuller',
    confirm_project_delete: 'Slet',
  },
  force_update:
    'Der sker spændende ting! Opdatér <a href="/" onClick=\'javascript:window.location.reload();\'>browseren</a> for at sikre, at du bruger den nyeste version af WeTransfer.',
  user: {
    already_logged_in:
      'Du er allerede logget ind – er du sikker på, at du vil nulstille adgangskoden?',
    roles: {
      admin: 'Admin',
      owner: 'ejer',
      user: 'bruger',
    },
    sign_out_and_reset: 'Log ud, og nulstil adgangskode',
  },
  click_here: 'Klik her',
  cookiebox: {
    notice:
      '<bold>Du er i øjeblikket logget ind</bold>, du vil blive logget ud, når dine cookies er fjernet. Tidligere overførsler på din konto påvirkes ikke.',
  },
  notice: {
    general_issues:
      'Virker tingene ikke, som de skal? Vi ved, at det er frustrerende, men hæng i, så skal vi nok få det hele op at køre <a target="_blank" href=%{link}>så snart, vi kan</a>',
    transfer_issues:
      'Er der problemer med din overførsel? Vi ved, at det er frustrerende, men hæng i, så skal vi nok få det hele op at køre <a target="_blank" href=%{link}>så snart, vi kan</a>',
    verification:
      'Hej, vi skal bede dig <a href="/account">bekræfte din e-mail</a>',
  },
  site: {
    name: 'WeTransfer',
    titles: {
      about: 'Om | WeTransfer',
      advertise: 'Annoncér med os | WeTransfer',
      apps: 'Gratis apps til Mac, iOS og Android | WeTransfer Apps',
      forgot_password: 'Nulstil adgangskode | WeTransfer Pro',
      help: 'Sådan sender du store filer | WeTransfer Hjælp',
      home: 'Del nemt store filer gratis | WeTransfer',
      plus: 'Opgrader for at sende større filer | WeTransfer Pro',
      sign_in: 'Log ind | WeTransfer Pro',
      sign_up: 'Tilmeld dig | WeTransfer Pro',
      upgrade: 'Opgrader | WeTransfer Pro',
      pricing:
        'Priser | WeTransfer - Send store filer og del fotos online – op til 2 GB er gratis',
    },
    descriptions: {
      help: 'Need WeTransfer tech support? Find out how to send large files in our Quick Help section or get in touch.',
      social_help: 'Har du stadig ikke fundet det, du leder efter?',
    },
  },
  splash: {
    footer: {
      or: 'eller',
      send_files: 'Jeg ønsker bare at sende mine filer',
      no_thanks: 'Nej tak',
    },
    heading: {
      line_1_free:
        'WeTransfer er den bedste metode til fremsendelse af store filer',
      line_2_free: 'Få mere ud af WeTransfer',
      free_account: 'Velkommen tilbage. Skal vi gøre det officielt?',
    },
    plan: {
      plus: {
        feature_10: 'Tilpas dine e-mails',
        feature_11: 'Gem op til %{plus_storage_limit}',
        feature_12: 'Beslut, hvornår overførsler skal udløbe',
        feature_13: 'Beskyt dine overførsler med en adgangskode',
        feature_7: 'Gør din profil personlig',
        feature_8: 'Opret din egen adressebog',
        feature_9: 'Tilpas din WeTransfer-URL',
      },
      free_account: {
        cta: 'Tilmeld dig gratis',
        feature_1: 'Ingen lagerplads',
        feature_2: 'Send op til %{free_transfer_limit}',
        feature_3: 'Gensend og slet overførsler',
        heading: 'WeTransfer-konto',
        price_label: 'For evigt gratis',
      },
      pro: {
        cta: 'Få WeTransfer Pro',
        feature_1: '%{storage_limit_pro} lagerplads',
        feature_2: 'Send og modtag op til %{transfer_limit_pro}',
        feature_2_unlimited: 'Send og modtag filer uden størrelsesbegrænsning',
        feature_3: 'Gensend og slet overførsler',
        feature_4: 'Beskyt overførsler med en adgangskode',
        feature_5: 'Din egen Pro-side og personlige URL',
        heading: 'WeTransfer',
      },
    },
  },
  tooltip: {
    team_discovery: {
      title: 'Vil du føje %{recipient} til dit team?',
      text_content:
        'Holdmedlemmer kan få adgang til hinandens overførsler med delt lagerplads og branding. Det vil ikke annullere din overførsel.',
      cta: 'Sæt i gang',
    },
  },
  transfer_link: {
    buttons: {
      copied: 'Link kopieret',
      copy: 'Kopier link',
      copy_again: 'Kopier igen',
    },
    labels: {
      share: 'Del denne overførsel',
    },
  },
  callout: {
    pill: {
      pro_onboarding: 'PRO-TIP',
    },
    'portals-onboarding': {
      'first-viewing': {
        cta: 'Prøv portals',
        dismiss: 'Ikke nu',
        text: 'Du kan invitere kunder og samarbejdspartnere til at se dit arbejde og vælge deres favoritter med <strong>portals</strong>. Hurra for ikke at maile frem og tilbage.',
        title: 'Skal du bruge feedback på dit arbejde—gerne hurtigt?',
      },
      'second-viewing': {
        cta: 'Prøv portals nu',
        dismiss: 'Vis ikke dette igen',
        text: 'Modtag hurtig feedback, og del nye versioner—alt på samme sted. Med <strong>portals</strong> kan du skabe et godt arbejdsflow fra gennemgang og redigering til den endelige godkendelse.',
        title: 'Du har sendt dit arbejde. Hvad så nu?',
      },
    },
    pro_onboarding: {
      admin: {
        cta: 'Gå til Branding',
        text_2: 'Vil du tilføje dine egne videoer eller billeder?',
      },
      individual: {
        cta: 'Tilpas siden',
        text: 'Giv folk et godt indtryk, hver gang de downloader dine filer - tilføj videoer eller billeder, og vælg din egen url.',
        title: 'Sæt dit aftryk med din egen WeTransfer-side',
      },
      invitee: {
        cta: 'Forstået',
        text_1:
          'Med en WeTransfer-side skræddersyet til jeres team gør I et godt indtryk, hver gang I deler jeres arbejde.',
        text_2:
          'Du kan skifte teamets baggrundsbilleder til hver en tid under <strong>Branding </strong>.',
        title: 'Lad dem se jeres (hold)arbejde',
      },
      not_now: 'Ikke nu',
    },
  },
  cue: {
    inline: {
      teams: {
        onboarding: {
          transfers: {
            received: {
              mini: {
                branding_incomplete: {
                  cta: 'Tilpas siden',
                  premium: {
                    text: 'Alle kan sende dig filer af enhver størrelse fra dit teams WeTransfer-side.',
                  },
                  text: 'Alle kan sende dig %{transfer_limit_pro} overførsler fra dit teams WeTransfer-side',
                },
                premium: {
                  transfer_link: {
                    text: 'Alle kan sende dig filer af enhver størrelse fra %{custom_link}',
                  },
                },
                transfer_link: {
                  text: 'Alle kan sende dig op til %{transfer_limit_pro}-overføsler fra %{custom_link}',
                },
              },
              premium: {
                text: 'Alle kan sende dig overførsler af enhver størrelse fra dit teams WeTransfer-side - bare giv dem dette link.',
              },
              regular: {
                cta: 'Forstået',
                text: 'Alle kan sende jer <strong>%{transfer_limit_pro}</strong>-overførsler fra teamets egen WeTransfer-side. Bare giv dem dette link.',
                title: 'Alt hvad jeres team modtager samlet på ét sted',
              },
            },
            sent: {
              regular: {
                cta: 'Forstået',
                text: 'Velkommen til jeres delte oversigt over teamets sendte overførsler. Her kan du se jeres downloads, ændre i udløbsdatoer og også redigere eller slette andres overførsler—men husk, at det er god stil at give dem besked inden!',
                title: 'Håndter teamets overførsler',
              },
            },
          },
        },
      },
    },
  },
  feature_banner: {
    pro: 'WeTransfer Plus hedder nu WeTransfer Pro med 1 TB lagerplads — 10 x mere end før. <a href="/transfers">Læs mere.</a>',
  },
  refer_friend: {
    title: 'Henvis venner',
    account: {
      description:
        'Vi giver dig og en ven 10 USD hver, når de tilmelder sig WeTransfer Pro eller Premium. Del dit henvisningslink for at blive belønnet med forudbetalte kort, velgørenhedsdonationer eller gavekort fra hundredvis af partnere.',
    },
    window: {
      link: 'Få henvisningslink',
      send_another: 'Fortsæt',
      text: 'Vi giver dig og en ven <strong>10 USD</strong> hver, når de tilmelder sig WeTransfer Pro eller Premium.',
      title: 'Henvis en ven',
      title_2: 'for at sende overførsler.',
    },
    message: {
      success:
        'Du har en rigtig god ven her! Tilmeld dig WeTransfer Pro eller Premium, og I får hver et forudbetalt kort, en velgørenhedsdonation eller et gavekort til en værdi af 10 USD.',
      self: 'Åh nej, det henvisningslink ser ikke rigtigt ud. Bed din ven om et nyt link for at modtage 10 USD, når du tilmelder dig WeTransfer Pro eller Premium.',
      fallback:
        'Åh nej, det henvisningslink ser ikke rigtigt ud. Bed din ven om et nyt link for at modtage 10 USD, når du tilmelder dig WeTransfer Pro eller Premium.',
      expired: 'Beklager, dit henvisningslink er udløbet.',
      dismiss: 'Afvis',
    },
  },
  order_summary: {
    coupon: {
      link: 'Anvend kampagnekode',
      input_placeholder: 'Kampagnekode',
      button_label: 'Anvend',
      error_message:
        'Denne kode kan desværre kun bruges til at spare på et %{billing_period} abonnement.',
      generic_error_message:
        'Denne kode er desværre ikke kompatibel med dette abonnement',
      input_error_message: 'Beklager, dette er ikke en gyldig kode.',
      pill_label: {
        percentage: '-%{percentage} %',
      },
    },
    total: 'I alt',
  },
  mobile_verify: {
    title: 'Du er klar',
    subtitle:
      'Din e-mail er blevet bekræftet og du kan nu bruge appen til at sende og modtage overførsler.',
    cta: 'Åbn WeTransfer-appen',
  },
  pricing_panel: {
    current_solo_workspace_information:
      'Dit nuværende abonnement på <b>%{formattedintervaltotal}</b>/%{subscriptioninterval} vil automatisk blive fornyet den <b>%{autorenewalattempt}</b>',
    current_team_workspace_information:
      'Dit nuværende abonnement på <b>%{formattedTeamWorkspaceCost}</b>/%{subscriptioninterval} <br>(%{membercount} x %{tieramount}) vil automatisk blive fornyet den <b>%{autorenewalattempt}</b>',
    next_payment_date:
      'Din næste betalingsdato er <b>%{recurring_billing_date}</b>',
    upgrade_price: '<b>%{totalprice}</b>/%{interval}',
    team_upgrade_calculation: '(%{membercount} medlemmer x %{tierprice})',
    premium_title: 'WeTransfer Premium',
    premium_feature_one: 'Ingen begrænsinger af størrelsen på overførsler',
    premium_feature_two: 'Ubegrænset lagerplads',
    premium_feature_three: 'Ubegrænset antal portaler og gennemgange',
    premium_feature_four:
      'Se <a class="all-benefits-link" href="%{all_benefits_href}">alle fordele</a>',
    premium_switch_cta_text: 'Skift til Premium',
    pill_text: 'Nuværende abonnement',
    member_count: '%{membercount} medlemmer',
    see_all_benefits: 'Se alle fordelene ved abonnementet',
    pending_downgrade_current_subscription:
      'Dit arbejdsområdeabonnement er blevet annulleret og udløber den <b>%{cancellation_date}</b>.',
    pending_downgrade_reactivate_text:
      'Har du fortrudt? Bare rolig, det er nemt at få tingene op at køre igen.',
    pending_downgrade_reactivate_cta: 'Genaktiver Pro',
    pending_downgrade_payment: 'Du har ingen kommende betalinger',
    update_payment_cta: 'Opdater betalingsoplysninger',
    cancel_plan:
      'Hvis du opsiger dit abonnement, kan du få adgang til dit %{planName} arbejdsområde indtil den %{subscriptionRenewalDate}. ',
    cancel_expiry_text:
      'Dit arbejdsområde vil derefter blive nedgraderet til det gratis abonnement, og dine eksisterende overførsler udløber efter 28 dage.',
    pending_payment_text:
      'Gennemfør betalingen eller annuller ordren for at se oplysninger om abonnement og betaling.',
    learn_more: 'Få mere at vide om abonnementer og priser',
  },
  time: {
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },
    remaining: {
      minutes: {
        zero: 'Under a minute remaining',
        one: 'About 1 minute remaining',
        other: 'About %{count} minutes remaining',
      },
      hours: {
        one: 'About an hour remaining',
        other: 'About %{count} hours remaining',
      },
    },
  },
  download: {
    shortcut: 'Press %{command} to see the<br />download progress',
    shortcuts: {
      control_j: 'Ctrl-J',
      control_alt_l: 'Ctrl-Alt-L',
      cmd_shift_j: '&#8984;-Shift-J',
      cmd_j: '&#8984;-J',
      cmd_alt_l: '&#8984;-Alt-L',
    },
  },
  upload: {
    title: 'Send up to %{size}',
    progress: {
      busy: 'Transferring...',
    },
    buttons: {
      add: 'Add files',
      transfer: 'Transfer',
      forward: 'Forward',
    },
    forward: {
      done: 'Forward complete',
    },
    friend_email: {
      title: "Friend's email",
      more: 'Add more friends',
    },
    your_email: {
      title: 'Your email',
    },
    message: {
      title: 'Message',
    },
    done: {
      title: 'Transfer complete',
      link: 'Copy your download link:',
      copied: {
        title: 'Copied!',
        text: 'The download link has been copied.',
      },
    },
    more_html: 'Add more files<span>(%{size} left)</span>',
    too_many_recipients:
      "Seems like you've entered too many email addresses. Remember: there's room for up to %{count} people at a time.",
    completed: '%{size} of %{total} completed',
    addresses: {
      one: '%{count} address',
      other: '%{count} addresses',
      remove: 'Do you want to remove %{address} from your previous recipients?',
    },
    ads: {
      plus: {
        title: 'Get more out<br />of WeTransfer<br />with Pro',
        text: "<ul><li>Supersized uploads</li><li>Personalised transfers with your own backgrounds</li><li>Password protected transfers</li><li>Long term storage</li></ul><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      plus2: {
        title: 'Impress<br />with your<br />own custom download page',
        text: "<p>Use your own backgrounds and custom WeTransfer URL (yourname.wetransfer.com)<br />to impress your recipients.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      plus3: {
        title: 'Manage<br />your transfers smarter',
        text: "<p>This transfer is deleted after a week, but with WeTransfer Pro you can store indefinitely, resend and delete instantly, without having to upload again.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      plus4: {
        title: 'Get extra protection<br />for your files',
        text: "<p>With WeTransfer Pro, you can protect your important and confidential files with a password.</p><p>That way they will never fall into the wrong hands.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      facebook: {
        title: 'Join the<br />WeTransfer<br />community<br />on Facebook',
        text: "<p>Get the latest news, win prizes, discover new artists, read interviews and much more.</p><p><a target='_blank' href='https://www.facebook.com/wetransfer'>Find out more</a></p>",
      },
      flipflops: {
        title: 'Free flipflops by WeTransfer',
        text: "<p style='text-align:center;'><img src='/assets/flipflops.jpg'></p><p>As a thank you from us, we've teamed up with Suavesoles to get you this fantastic pair of flipflops for free!<br /><a target='_blank' href='http://suavesoles.com/we-transfer/?ref=wt-app'>Order now</a></p>",
      },
    },
    errors: {
      only_email: 'Sorry, only email is supported when resending a transfer.',
      connect_twitter:
        'Your Twitter account is not yet connected to WeTransfer.',
      connect_facebook:
        'Your Facebook account is not yet connected to WeTransfer.',
      transferproblems: {
        title: 'Transfer problem',
        text: 'Hate to break it to you, but something went wrong with the transfer.',
      },
      limitreached: {
        title: 'Storage Limit',
        text: 'You reached your 1 TB limit. Delete some old transfers to send new files',
      },
      blocked: {
        title: 'Transfer problem',
        text: 'Computer says no. Sorry, but you have been blocked from WeTransfer.',
      },
      upload_error: {
        title: 'Transfer problem',
        text: 'Hate to break it to you, but something went wrong with the transfer.',
      },
      unavailable: {
        title: 'Transfer error',
        text: 'Sorry, this transfer has already been deleted so it cannot be forwarded.',
      },
      startswithdot: {
        title: 'Oops',
        text: "One (or more) of your files has a name that starts with a full stop. That's not going to work. Please rename the file(s), and try adding them again.",
      },
      startswithspace: {
        title: 'Oops',
        text: "One (or more) of your files has a name that starts with a space. That's not going to work. Please rename the file(s), and try adding them again.",
      },
      containsreturn: {
        title: 'Oops',
        text: "One (or more) of your files has a name that contains a return. We don't know quite how you've done that, but it's not going to work. Please rename the file(s), and try adding them again.",
      },
      alreadyinlist: {
        title: 'Yikes',
        text: "Turns out one of your files had the same name as another file that you've already selected. Change it up a little!",
      },
      transfertoobig: {
        title: 'Uh-oh',
        text: "Ever so sorry, but we can't transfer more than %{upload_limit}GB at a time.",
      },
      filetoobig: {
        title: 'Uh-oh',
        text: "Ever so sorry, but we can't transfer more than %{upload_limit}GB at a time.",
      },
      zerobytes: {
        title: 'Whoops',
        text: 'One (or more) of your files is empty or could not be read.',
      },
      ioerror: {
        title: 'Fail',
        text: "One (or more) of your files could not be read or is larger than %{upload_limit}GB. That's not going to fly.",
      },
      filenametoolong: {
        title: 'Yikes',
        text: "One (or more) of your files has a filename that is longer than 250 characters. We can't accept filenames longer than this, so please rename it.",
      },
      nofolders: {
        title: 'Uh-oh',
        text: "Sorry, uploading folders doesn't work yet. Try zipping it first.",
      },
      nofiles: {
        title: 'Oops',
        text: "You haven't actually added any files yet.",
      },
      norecipients: {
        title: 'Doh!',
        text: 'Looks like you forgot to enter any email addresses to send to.',
      },
      toomanyrecipients: {
        title: 'Yikes',
        text: 'Too many recipients.',
      },
      bigmessage: {
        title: 'Oops',
        text: 'Your message is longer than a novel. Please make it shorter.',
      },
      nosender: {
        title: 'Seriously?',
        text: 'You forgot to enter your own email address. How could you?',
      },
      senderemailinvalidformat: {
        title: 'Uh-oh',
        text: 'Your email address appears to be incorrect. Mind your spelling!',
      },
      probablynotcopied: {
        title: 'Oops',
        text: "It looks like you haven't copied the link.",
      },
      recipientemailinvalidformat: {
        title: 'Oops',
        text: "You entered one of your friend's email addresses incorrectly.",
      },
      requiresdefaultrecipient: {
        title: 'Uh-oh',
        text: 'Sorry! You can only send more than 2GB to the Pro Channel owner. Refresh the page to start again.',
      },
      containsbackslash: {
        title: 'Yikes',
        text: "One (or more) of your files has a filename that contains a backslash. We can't accept this, so please rename the files so they don't contain the backslash.",
      },
    },
    tips: {
      maxfilesize_tip: {
        title: 'Tip',
        text: "You can send up to 2GB per transfer. And what's even better: you can transfer as often as you like.",
      },
      maxfilesize_oldbrowser_tip: {
        title: 'Important',
        text: "Your Pro account can send up to 20 GB per transfer, but your browser is preventing this. <a href='/questions/33'>Click here for more information</a>",
      },
      recipients_tip: {
        title: 'Tip',
        text: 'You can enter up to %{email_limit} email addresses to send to. If you just want a download link, click on the share button below.',
      },
      default_recipient: {
        title: 'Tip',
        text: 'To send over 2GB, make sure you upload your files to the Pro Channel owner only. Refreshing the page will pre-fill their address for you.',
      },
      sender_tip: {
        title: 'Tip',
        text: 'Pop your own email address in here so we can contact you when the files have been downloaded.',
      },
      expire_tip: {
        title: 'Tip',
        text: 'You can now change the expiry date of your Pro transfers.',
      },
      message_tip: {
        title: 'Tip',
        text: "Want to send your friends a message along with the files? Here's your chance - but you don’t have to.",
      },
      share_tip: {
        title: 'Tip',
        text: 'Change the way you share your files. Send them by email or grab a download link.',
        text_plus:
          'Change the way you share your files. Send them by email, Twitter, Facebook, or grab a download link.',
      },
      download: {
        title: '',
        chrome:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The download progress should be visible at the bottom of your browser window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out how to change this behaviour here</a>.",
        firefox:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible in your browser's Download window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        safari:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible in the top right corner of your browser window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        old_explorer:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. You may also see a security alert at the top of the browser window. <a href='/questions/24' target='_blank'>Find out more</a>.",
        explorer:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible at the bottom of your browser window (you may need to click on Save first), and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        settings:
          'You can change your default download location in your browser settings.',
      },
    },
  },
  warnings: {
    unsaved_changed:
      'You have made changes to your Channel. Are you sure you want to leave this page without saving?',
    forwarding: 'Forwarding this transfer will clear the form, are you sure?',
    is_busy: "Sorry, we can't do this right now",
  },
  mobile_app: {
    remember_choice: "Don't show this message again",
    uploader: {
      description:
        'Our site is not optimised for mobile right now. But we do have a shiny mobile app.',
      app_name: 'WeTransfer',
      download: 'Download the App',
      continue: 'Continue to WeTransfer.com',
    },
    downloader: {
      title: 'Your files are ready for download!',
      description_ios:
        'We\'ve bundled your files in a zip file. You will need an app to extract and view the files. We think "<a href="https://itunes.apple.com/us/app/winzip/id500637987?mt=8">Winzip</a>" is a pretty good app for that.',
      description_android:
        'We\'ve bundled your files in a zip file. You will need an app to extract and view the files. We think "<a href="https://play.google.com/store/apps/details?id=com.estrongs.android.pop&hl=en">ES File Explorer</a>" is a pretty good app for that.',
      continue: 'Understood',
    },
  },
};
